import { loadAuthCss, authCssReady } from './authCss';
import React, { Component, createRef } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import Fishing from "./fising";
import Sport from "./sport";
import TextSlider from "./textslide";
import Afficiate from "./affiliate";
import Signin from "./signin";
import Register from "./register";
import Loss from "./loss";
import Luckywhell from "./luckyfortune";
import Checkindaily from "./checkin";
import Cardminigame from "./cardminigame";
import Promotion from "./promotionx";
// import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";
import Banner from "./banner";
import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
import Popup from "./popup";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import axios from 'axios';
import io from "socket.io-client";
var settings = {
    dots: false, // ซ่อนจุดนำทาง
    infinite: true, // วนลูป slides
    slidesToShow: 3, // แสดง 3 slide ในหน้าจอใหญ่
    slidesToScroll: 1, // เลื่อนทีละ 1 slide
    autoplay: true, // autoplay
    speed: 2000, // ความเร็วในการเลื่อน (ms)
    autoplaySpeed: 3000, // ช่วงเวลาระหว่าง autoplay
    cssEase: "linear", // ความเรียบเนียนของ transition
    centerMode: true, // แสดง slide ตรงกลาง
    centerPadding: "20px", // ระยะห่างซ้าย-ขวาของ slides
    responsive: [
        {
            breakpoint: 1024, // เมื่อหน้าจอเล็กกว่า 1024px
            settings: {
                slidesToShow: 2, // แสดง 2 slide
                centerPadding: "15px", // ระยะห่างลดลง
            },
        },
        {
            breakpoint: 760, // เมื่อหน้าจอเล็กกว่า 760px
            settings: {
                slidesToShow: 1, // แสดง 1 slide
                centerPadding: "10px", // ระยะห่างลดลงอีก
            },
        },
    ],
};

const settingsx = {
    dots: true, // แสดงจุดบอกสถานะของสไลด์
    infinite: true, // สไลด์วนลูป
    speed: 500, // ความเร็วในการเลื่อนสไลด์ (ms)
    slidesToShow: 1, // จำนวนสไลด์ที่แสดง
    slidesToScroll: 1, // จำนวนสไลด์ที่เลื่อนต่อครั้ง
    autoplay: true, // เลื่อนอัตโนมัติ
    autoplaySpeed: 3000, // เวลาในแต่ละสไลด์ (ms)
    arrows: true // แสดงปุ่มเลื่อนซ้าย-ขวา
};

let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cssReady: authCssReady(), // [2026-11-04] รอ CSS หน้าสมาชิกก่อนแสดง (กันกระพริบ)
            ios: true,
            isWithdrawLoading: false,
            withdrawLockedUntil: Number(localStorage.getItem("withdrawLockedUntil") || 0),
            nowTs: Date.now(),
            redirectCountdown: 0,
            finish: 0,
            tabselectselect: 1,
            webnamexback: "",
            dateselect: moment(new Date()).format("YYYY/MM/DD"),
            inputTimeHour: moment(new Date()).format("HH"),
            inputTimeMin: moment(new Date()).format("mm"),
            isUploading: false,
            openAccordion: null,
            webname: "",
            previewUrl: null,
            usercheck: "",
            categorylist: [],
            isPopupOpen: false,
            selectedItem: null, // Store the selected item
            luckywheeldisplay: false,
            listitallgame: [],
            slotlist: [],
            sportlist: [],
            logoimg: '',
            describemain: "",
            fishinglist: [],
            gamehitlist: [],
            files: [],
            providorlist: [],
            filterlist: [],
            stats: {},
            isConfirmed: false,
            reports: {},
            qrstep: 1,
            listacc: [],
            addhome: true,
            whellsetting: [],
            pglist: [],
            tabselectdeposit: 0,
            rewardlist: [],
            loader: false,
            slotlist: [],
            recentlist: [],
            activePage: 1,
            ThmeseV: null,
            pagecount: 1,
            trueaccount: true,
            products_page_count: 1,
            isActive: false,
            resetpass: 0,
            paymentlist: null,
            checkcredit: false,
            refer: 1,
            showmodal: false,
            historylist: [],
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            afficiate: [],
            cashoutSet: [],
            modal: false,
            modalpromotion: false,
            linkaff: "",
            point: 0,
            maxwithdrawstatus: 0,
            useradvice: [],
            afficiatetoday: [],
            afficiateall: [],
            balance: 0,
            counter: 300,
            partner: null,
            qrcodecheck: false,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            prolistx: [],
            prodetail: [],
            username: "",
            tabselect: 0,
            showpass: false,
            amount: "",
            remark: "",

            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            limit: null,
            name: "",
            password: "",
            oldpassword: "",
            passwordcf: "",
            left: false,
            pathname: "",
            linelink: "",
            lineid: "",
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            pagecount: 1,
            picture: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            mainacc: [],
            paymentgateway: null,
            tabselectsec: 0,
            checkcashout: false,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            activeTab: 'deposit-history', // ค่าเริ่มต้น
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
            modalx: false,
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            hours: 0,
            minutes: 0,
            seconds: 0
        }
        this.timer = null; // เก็บตัวนับเวลา
        this.popupRef = createRef();
    }
    handleClickOutside = (event) => {
        const isOutside =
            !event.target.closest('[role="dialog"]'); // ตรวจสอบว่า target อยู่นอก role="presentation"
        if (isOutside) {
            this.closeModal();
        }
    };
    handleTabChange = (tabId) => {
        this.setState({ activeTab: tabId });
    };

    toggleAccordion = (id) => {
        this.setState((prev) => ({
            openAccordion: prev.openAccordion === id ? null : id
        }));
    };

    handleChange = (event) => {
        console.log(event.target.value);
        const { name, value } = event.target;
        this.setState({
            [name]: value,
        });
    };
    getwheel = async () => {
        const cacheKey = "wheelSpinCache";
        const cacheTTL = 10 * 60 * 1000; // 10 นาทีในมิลลิวินาที
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        // ตรวจสอบว่ามีแคชและยังไม่หมดอายุ
        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data wheelSpinCache");
            this.setState({
                tblwheelsetting: cachedData.data.tblwheelsetting,
                segments: cachedData.data.segments,
                segColors: cachedData.data.segColors,
            });
            return;
        }

        try {
            const res = await instance.post("/api/v1/getwheelspin", {
                System: Systems,
            });

            console.log("getwheelspin", res.data);
            if (res.data.status === 200) {
                const datas = res.data.message;
                const segments = [];
                const segColors = [];

                for (let i = 0; i < datas.length; i++) {
                    const { id, description: name, color, image } = datas[i];
                    segments.push({ id, name, image });
                    segColors.push(color);
                }

                const newData = {
                    tblwheelsetting: res.data.tblwheelsetting,
                    segments,
                    segColors,
                };

                this.setState(newData);

                // เก็บข้อมูลลงในแคช
                localStorage.setItem(cacheKey, JSON.stringify({
                    timestamp: Date.now(),
                    data: newData,
                }));

                console.log("Segments:", segments);
            } else {
                // Handle other statuses if needed
                console.log("Error: Status not 200");
            }
        } catch (error) {
            console.log("Error:", error);
        }
    };
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        console.log("fname", fname);
        if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
            var title = 'error'
            var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (fname === "" || fname === null || fname === undefined) {

            var title = 'error'
            var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (password.length > 15) {
            var title = 'error'
            var text = 'Password สูงสุดไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'พาสเวิดต่ำไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'Password มากกว่า 6 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = 'ทำการสมัครเรียบร้อย กรุณารอสักครู่'
                    var object = { title, text }
                    await this.modalerror(object);

                    this.setState({
                        username: phoneNumber,
                        password: password,
                        finish: 1,
                    });


                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }


    };
    handleClickmodal = () => {
        // console.log(this.state.modalx);
        // if (!this.state.modalx) {
        //     //document.addEventListener("click", this.handleOutsideClick, false);
        // } else {
        //     document.removeEventListener("click", this.handleOutsideClick, false);
        // }

        // this.setState(prevState => ({
        //     modalx: !prevState.modalx
        // }));
    };
    closeModal = () => {
        this.setState({ modalpopup: false });
    };
    handleIosClick = () => {
        this.setState({ ios: true });
    };
    handleAndroidClick = () => {
        this.setState({ ios: false });
    };
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        if (this.withdrawTimer) clearInterval(this.withdrawTimer);
        if (this.redirectTimer) clearInterval(this.redirectTimer);
        if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
        clearInterval(this.timer); // ล้างตัวนับเมื่อคอมโพเนนต์ถูกถอดออก
    }
    getNextMondayTarget() {
        const now = new Date();
        let target = new Date();

        // คำนวณวันจันทร์ถัดไป
        const daysUntilMonday = (8 - now.getDay()) % 7; // คำนวณจำนวนวันที่เหลือถึงวันจันทร์
        target.setDate(now.getDate() + daysUntilMonday);
        target.setHours(1, 0, 0, 0); // ตั้งเป้าหมายเป็น 01:00 AM ของวันจันทร์

        // ถ้าขณะนี้เลยเวลาเป้าหมายไปแล้ว ให้เลื่อนเป้าหมายไปวันจันทร์ถัดไป
        if (now >= target) {
            target.setDate(target.getDate() + 7);
        }

        return target;
    }

    startCountdown() {
        let targetTime = this.getNextMondayTarget();

        this.timer = setInterval(() => {
            const now = new Date();
            const diff = targetTime - now;

            // ถ้าถึงเวลาเป้าหมายแล้ว ให้ตั้งเป้าหมายใหม่
            if (diff <= 0) {
                targetTime = this.getNextMondayTarget();
            }

            // คำนวณวัน ชั่วโมง นาที และวินาทีที่เหลือ
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            // อัปเดตสถานะ (state)
            this.setState({
                days: days >= 0 ? days : 0,
                hours: hours >= 0 ? hours : 0,
                minutes: minutes >= 0 ? minutes : 0,
                seconds: seconds >= 0 ? seconds : 0
            });
        }, 1000);
    }
    redeemrank = async (e, index) => {
        e.preventDefault();
        //console.log(index);

        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'คุณต้องการเคลม Rank หรือ ไม่?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/userredeemrank", {
                        User_id: Username,
                        rankno: index.no,
                        System: Systems,
                        amount: index.claimamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            const datas = res.data.message;
                            this.calllisthistory(Username);
                            this.checklogin();
                            Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
                        }
                        else {
                            Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
                        }
                    });

                }
            })
        }

    }
    handleFileSelectedt = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const previewUrl = URL.createObjectURL(files[0]);
            this.setState({
                files: files,
                previewUrl: previewUrl,
                isConfirmed: false, // รีเซ็ตให้ต้องกดยืนยันใหม่
            });
        }
    };




    confirmqrcode = async () => {
        await Swal.fire({
            title: 'success!',
            text: 'ยืนยันการเติมเงิน',
            icon: 'success',
            confirmButtonText: 'ตกลง'
        })
        this.setState({
            tabselect: 0,
            qrcode: null,
            tabselectdeposit: 0,
        });
    };
    cancleqrcode = () => {
        Swal.fire({
            title: "ยกเลิก QR code",
            html: 'คุณต้องการยกเลิกการใช้ Qr code',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.setState({
                    qrstep: 0,
                    qrcodecheck: false,
                    counter: 0,
                });
            }
        });
    };
    promotionlist = () => {
        instance.post("/api/v1/getpromotion", {
            System: Systems,
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    prolistx: res.data.message,
                });
            }
        }).catch(async (err) => {
            console.log(err);

            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/login'; // [2026-11-04] เดิม '' = รีโหลดหน้าเดิม
            }
        });
    }
    login = (e) => {
        e.preventDefault();
        let errors = this.validateLoginForm();
    }
    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        console.log(username, password);
        await instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        })
            .then((res) => {
                console.log(res);
                if (res.status === 200) {
                    //////console.log(res.data.status);
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token)
                        localStorage.removeItem('cookie', '')
                        this.setState({
                            userid: res.data.message.member_id,
                            username: res.data.message.playerid,
                            firstname: res.data.message.firstname,
                            lastname: res.data.message.lastname,
                            point: res.data.message.Point,
                            balance: res.databalance,
                            loginstate: true,
                        });
                        window.location.href = '/';
                    }
                    else if (res.data.status === 401) {
                        Swal.fire({
                            title: 'error!',
                            text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'error!',
                            text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        })
                        //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
                    }
                }
                else {
                    this.setState({
                        firstname: null,
                        lastname: null,
                        point: null,
                        loginstate: false,
                    });
                    var title = 'Error!'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.CheckThisGoalError(object);
                }
            });
    }
    async checklogin() {
        var token = localStorage.getItem('auth_token');
        console.log(11111111, token);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        else {
            this.setState({
                loginstate: false,
            });
            await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
            console.log(this.state.webnamexback);
            window.location.href = '/login'; // [2026-11-04] เดิมไป selflink ใน BO (โดเมนอื่น + '//login' = หน้าหลัก)
        }
    }
    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }

    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.setState({
            checkcredit: true,
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            // console.log(2);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)

                    this.setState({
                        usercheck: res.data.message.usercheck,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                        checkcredit: false,
                    });
                }
                else if (res.data.status === 401) {
                    //   console.log(res.data);
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิม '' = รีโหลดหน้าเดิม
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิม '' = รีโหลดหน้าเดิม
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }
    }
    // async opencliamcashout(evt, cityName) {
    //     var token = localStorage.getItem('auth_token');
    //     var decoded = jwt_decode(token);
    //     var Username = decoded.message.playerid;
    //     await instance.post("/api/v1/cliamcashout", {
    //         userid: Username,
    //         System: Systems,
    //     }, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     }).then(async (res) => {
    //         if (res.data.status === 200) {
    //             var decoded = jwt_decode(token);
    //             var Username = decoded.message.playerid;
    //             this.rechecklogin(Username, token);
    //             await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
    //         }
    //         else if (res.data.status === 201) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
    //             return false;
    //         }
    //         else if (res.data.status === 202) {
    //             await this.notify("error", 'ไม่สามารถทำรายการได้');
    //             return false;
    //         }

    //     }).catch(async (err) => {
    //         // console.log(err);
    //         if (err.response.status === 401 || err.response.status === 403) {
    //             localStorage.clear();
    //             await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
    //             window.location.href = '/';
    //         }
    //     });
    // }
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    handleOutsideClick = e => {
        if (!this.node.contains(e.target)) this.handleClickmodal();
    };
    claerclass = async (e, url) => {
        var i, tabcontent, tablinks;
        tabcontent = document.querySelectorAll('[id*="game"]');
        Array.prototype.forEach.call(tabcontent, callback);
        function callback(element, iterator) {
            if (!isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-luxecs";
            }
            else if (isMobile) {
                element.className = "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-5oh6yz";
            }
        }
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    handleSelectItem = (item) => {
        if (item.id == 99) {
            this.setState({
                trueaccount: false,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
            });
        }
        else {
            this.setState({
                trueaccount: true,
                selectedItem: item,
                isPopupOpen: false,
                bankselect: item.id,
                fname: ""
            });
        }
        //  this.setState({}); // Store selected item and close menu
    };
    handleSubmit = async (event) => {
        event.preventDefault();
        const { oldPassword, newPassword, confirmPassword } = this.state;
        // console.log(type, newPassword, oldPassword, confirmPassword);
        var token = localStorage.getItem('auth_token');
        if (newPassword === confirmPassword) {
            var Username = null;
            var decoded = null;
            if (newPassword != oldPassword) {
                if (token != null) {
                    decoded = jwt_decode(token);
                    Username = decoded.message.playerid;
                    await instance.post("/api/v1/resetpassword", {
                        username: Username,
                        oldpass: oldPassword,
                        System: Systems,
                        newpass: newPassword,
                        type: 1
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.setState({
                                tabprofile: 1,
                            });
                            await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                        }
                        else if (res.data.status === 203) {
                            await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                        }
                    });
                }
                else {
                    await this.notify("error", 'ทำรายการไม่สำเร็จ');
                }
            }
            else {
                await this.notify("error", 'คุณใส่รหัสผ่านเดิม');
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }

    }
    closewheel(e) {
        e.preventDefault(); // ป้องกันพฤติกรรมเริ่มต้น
        this.setState({ luckywheeldisplay: false }); // ซ่อน Lucky Wheel
    }
    handleConfirmUpload = () => {
        if (this.state.files.length === 0) {
            this.notify("error", "กรุณาเลือกไฟล์ก่อนยืนยัน!");
            return;
        }
        this.setState({ isConfirmed: true }, () => {
            this.uploadSlip();
        });
    };


    uploadSlip = async () => {
        const { files, depositAmount, dateselect, inputTimeHour, inputTimeMin, mainacc } = this.state;
        const token = localStorage.getItem("auth_token");

        if (!token) {
            return this.notify("error", "ยังไม่ได้เข้าสู่ระบบ");
        }

        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;
            // [2026-11-04] เดิมอัปโหลดไป apixgen.javisx.com:8801 (เซิร์ฟเวอร์นี้ต่อไม่ได้แล้ว) -> ใช้ R2 แบบเดียวกับเว็บอื่น
            const ext = ((files[0].name || '').match(/\.([a-z0-9]+)$/i)?.[1] || "jpg").toLowerCase();
            const filename = `slip_${Username}_${Date.now()}.${ext}`;
            const formData = new FormData();
            formData.append("file", files[0], filename);
            formData.append("filename", filename);
            const headers = { "Content-Type": "multipart/form-data" };

            const slip = await axios
                .post("https://r2-public.wordbalance931.workers.dev/upload/slip", formData, { headers })
                .then((res) => res.data.link)
                .catch((error) => {
                    console.error("เกิดข้อผิดพลาด:", error);
                    return null;
                });

            if (!slip) {
                return this.notify("error", "อัปโหลดสลิปไม่สำเร็จ");
            }

            const object = {
                playerid: Username,
                amount: 1,
                date: dateselect,
                minute: inputTimeMin,
                hour: inputTimeHour,
                bank: mainacc,
                slipimg: slip,
                System: Systems,
                type: 0,
            };

            await instance.post("/api/v1/updateslip", object).then(async (res) => {
                console.log(269, res.data);
                if (res.data.status == 200) {
                    await this.notify("success", 'ดำเนินการเรียบร้อย');
                }
                else {
                    await this.notify("error", res.data.message);
                    this.setState({ isUploading: false, isConfirmed: false });
                }
            });

        } catch (error) {
            this.notify("error", error.message);
        }
    };
    checkurl = async (e, url) => {
        NProgress.start();
        const pathname = url.split("/")
        console.log(210, url.split("/"));
        if (pathname.length > 1) {
            if (!this.state.loginstate && pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 23,
                });
                return;
            }
            else if (pathname[1] == "ulive") {
                // [2026-11-04] Ulive เป็นหน้าแยก (route /ulive) -> ไปแท็บเดิมเลย ไม่ pushState ก่อน (กันประวัติซ้อน กดย้อนกลับแล้วกลับหน้าสมาชิกได้ตรง ๆ)
                window.location.href = "/ulive";
                return;
            }
            else {
                window.history.pushState(null, null, url);
                this.setState({
                    modalx: false,
                    modal: false,
                });
                if (pathname[1] == "") {
                    console.log(250, pathname[1]);
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "home") {
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "uploadslip") {
                    this.setState({
                        tabselect: 35,
                    });
                }
                else if (pathname[1] == "ulive") {
                    window.location.href = "/ulive"; // (ไม่ถึงบรรทัดนี้แล้ว — จัดการด้านบน)
                }

                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "luckywheel") {
                    this.setState({
                        tabselect: 33,
                    });
                }
                else if (pathname[1] == "checkindaily") {
                    this.setState({
                        tabselect: 36,
                    });
                }
                else if (pathname[1] == "cardminigame") {
                    this.setState({
                        tabselect: 37,
                    });
                }
                else if (pathname[1] == "slot") {
                    console.log(101, pathname);
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }

                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    this.setState({
                        tabselect: 1,
                        tabselectdeposit: 1,
                    });
                }
                else if (pathname[1] == "history") {
                    this.setState({
                        tabselect: 3,
                    });
                }
                else if (pathname[1] == "profile") {
                    this.setState({
                        tabselect: 8,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "afficiate") {
                    this.setState({
                        tabselect: 4,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3], true);
                    console.log(614, check)
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }
        NProgress.done();
    }
    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            console.log(864, res.data);
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                this.setState({
                    historylist: []
                });
                // this.CheckThisGoalError();
            }
        });

    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }
        return recheck
    }
    async modalerror(object) {
        await this.notify(object.title, object.text);
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log(num);
        if (num === 1) {
            const check = await this.forgetotpandregister(6);
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
                }
                else {
                    await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรดรอสักครู่');
                }
            }
        }
        else if (num === 2) {

            if (password === "" || password === null) {
                await this.notify("warning", 'คุณไม่ได้ไส่พาสเวิด');
            }
            else if (password.length < 6) {
                await this.notify("warning", 'โปรดใส่พาสเวิดมากกว่า 6 ตัว');
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน 6 ตัว');
                //////console.log(2, stateregis, checkboxacc);
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                this.setState({
                    stateopterror: "รหัสผิดพลาด"
                });
                await this.notify("warning", 'รหัสผิดพลาด');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }



        }
        else if (num === 11) {

            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            //////console.log(1, stateregis, num);
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            console.log("accnumbertxt", accnumbertxt);

            if (accnumbertxt === null || accnumbertxt === "" || typeof accnumbertxt == "undefined") {
                var title = 'error'
                var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
                var object = { title, text }
                this.modalerror(object);

            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status == 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status == 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = 'เลขบัญชีไม่ถูกต้อง'
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
                //console.log(302, check.verifications);
            }



        }
    };
    confirmdeposit = async (e, num, paymentstate = 0) => {
        console.log(493, num)
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                if (num === 0) {
                    if (token != null) {
                        Username = decoded.message.playerid;
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            paymentstate: paymentstate,
                            amount: this.state.depositamount,
                            status: 1
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            console.log(1067, res.data)
                            if (res.data.tblpaymentgatewayx != null) {
                                if (res.data?.tblpaymentgatewayx?.link) {
                                    const link = res.data.tblpaymentgatewayx.link;
                                    const ua = navigator.userAgent;
                                    console.log("tblpaymentgatewayx", res.data)
                                    const isIOS = /iPad|iPhone|iPod/.test(ua) ||
                                        (ua.includes("Mac") && "ontouchend" in document); // iPadOS

                                    if (isIOS) {
                                        // ✅ iOS ต้อง redirect ตรงเท่านั้น
                                        window.location.href = link;
                                    } else {
                                        // desktop + android
                                        if (!isMobile) {
                                            window.open(link, "_blank", "noopener,noreferrer,width=1000,height=1000");
                                        } else {
                                            window.open(link, "_blank");
                                        }
                                    }
                                }

                                else {
                                    this.setState({
                                        mainacc: res.data.mainacc,
                                        qrcode: res.data.tblpaymentgatewayx.QRcode,
                                        paymentlist: res.data.tblpaymentgatewayx,
                                        counter: 300,
                                        qrcodecheck: true,
                                    });
                                }
                            } else {
                                console.log(1067, res.data);
                                this.setState({
                                    mainacc: res.data.mainacc,
                                    qrcode: res.data.picture,
                                    paymentlist: res.data.tblpaymentgatewayx,
                                    counter: 300,
                                    qrcodecheck: true,
                                });
                            }
                            await this.notify("success", 'กรุณาสแกน qrcode ภายใน 5 นาที');
                        });

                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await this.notify("warning", 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ');

            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }

        else if (num === 5) {
            document.getElementById("truemonney").click()
            //deposittruemoneyModal
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    togglePopup = () => {
        this.setState((prevState) => ({
            isPopupOpen: !prevState.isPopupOpen,
        }));
    };

    onChange = async (event) => {
        console.log(1163, event);
        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            if (nam === "withdrawamount") {
                if (this.state.maxwithdrawstatus === 1) {
                    this.setState({ [nam]: this.state.balance });
                    await this.notify("warning", 'บังคับถอนยอดทั้งหมด');
                }
                else if (Number(val) <= Number(this.state.balance)) {
                    this.setState({ [nam]: val });
                }
                else {
                    await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');

                }
            } else {
                this.setState({ [nam]: val });
            }
            if (nam === "txtsech" || nam === "txtsech2") {
                const tabselect = this.state.tabselect
                let list = []
                let step = 1
                if (this.state.filterlist.length == 0) {
                    if (tabselect == 16 || tabselect == 20) {
                        list = this.state.listitallgame
                        step = 1
                    }
                    else if (tabselect == 13) {
                        list = this.state.slotlist
                        step = 2
                    }
                    else if (tabselect == 10) {
                        list = this.state.categorylist
                        step = 3
                    }
                    else if (tabselect == 14) {
                        list = this.state.sportlist
                        step = 4
                    }
                    else if (tabselect == 12) {
                        list = this.state.fishinglist
                        step = 5
                    }
                    else if (tabselect == 11) {
                        list = this.state.gamehitlist
                        step = 6
                    }
                    else if (tabselect == 18) {
                        list = this.state.providorlist
                        step = 7
                    }
                    this.setState({ filterlist: list });
                }
                else {
                    list = this.state.filterlist
                }
                let retailArrays = [];
                list.forEach(
                    array => {
                        console.log(1231, tabselect, step, array)
                        if (tabselect == 18 || tabselect == 10 || tabselect == 14) {
                            if (array.providername.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                        else {
                            if (array.description.toLowerCase().includes(val.toLowerCase())) {
                                retailArrays.push(array);
                            };
                        }
                    }
                )
                if (step == 1) this.setState({ listitallgame: retailArrays });
                else if (step == 2) this.setState({ slotlist: retailArrays });
                else if (step == 3) this.setState({ categorylist: retailArrays });
                else if (step == 4) this.setState({ sportlist: retailArrays });
                else if (step == 5) this.setState({ fishinglist: retailArrays });
                else if (step == 6) this.setState({ gamehitlist: retailArrays });
                else if (step == 7) this.setState({ providorlist: retailArrays });
            }

        }
    };
    submitwithdraw = async (e) => {
        try {
            if (this.state.isWithdrawLoading) return;

            const now = Date.now();
            const lockedUntil = Number(localStorage.getItem("withdrawLockedUntil") || 0);

            // ยังติดล็อกอยู่
            if (lockedUntil && now < lockedUntil) {
                const remainSec = Math.ceil((lockedUntil - now) / 1000);
                await this.notify("warning", `กรุณารอ ${remainSec} วินาที`);
                return;
            }

            console.log(this.state.withdrawamount, this.state.balance);

            if (parseFloat(this.state.withdrawamount) > parseFloat(this.state.balance)) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("warning", "ยอดถอนของท่านไม่เพียงพอในการถอน");
                return;
            }

            if (parseFloat(this.state.withdrawamount) < 50) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("warning", "ขั้นต่ำในการถอน 50 บาท");
                return;
            }

            const token = localStorage.getItem("auth_token");
            if (!token) {
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", "รายการถอนมีปัญหา โปรดติดต่อพนักงาน");
                return;
            }

            this.setState({ isWithdrawLoading: true });

            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;

            const res = await instance.post(
                "/api/v1/userwithdraw",
                {
                    User_id: Username,
                    System: Systems,
                    amount: this.state.withdrawamount
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            console.log(res.data);

            if (res.data.status === 200) {
                const successLock = Date.now() + 5 * 60 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(successLock));

                this.setState({
                    withdrawLockedUntil: successLock,
                    redirectCountdown: 5
                });

                await this.notify("success", "รายการถอนเรียบร้อย");

                if (this.redirectTimer) clearInterval(this.redirectTimer);
                if (this.redirectTimeout) clearTimeout(this.redirectTimeout);

                this.redirectTimer = setInterval(() => {
                    this.setState((prev) => {
                        if (prev.redirectCountdown <= 1) {
                            clearInterval(this.redirectTimer);
                            return { redirectCountdown: 0 };
                        }
                        return { redirectCountdown: prev.redirectCountdown - 1 };
                    });
                }, 1000);

                this.redirectTimeout = setTimeout(() => {
                    this.checkurl(e, "/history");
                }, 5000);

                return;
            }

            if (res.data.status === 203) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", "ท่านติด Turnover อีก " + res.data.amountturnover + " บาท");
                return;
            }

            if (res.data.status === 207) {
                // fail -> ล็อก 5 วินาที
                const failLock = Date.now() + 5 * 1000;
                localStorage.setItem("withdrawLockedUntil", String(failLock));
                this.setState({ withdrawLockedUntil: failLock });

                await this.notify("error", "ขั้นต่ำในการถอน " + res.data.maxwithdraw + " บาท");
                return;
            }

            // fail -> ล็อก 5 วินาที
            const failLock = Date.now() + 5 * 1000;
            localStorage.setItem("withdrawLockedUntil", String(failLock));
            this.setState({ withdrawLockedUntil: failLock });

            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
        } catch (error) {
            console.log("submitwithdraw error:", error);

            // error -> ล็อก 5 วินาที
            const failLock = Date.now() + 5 * 1000;
            localStorage.setItem("withdrawLockedUntil", String(failLock));
            this.setState({ withdrawLockedUntil: failLock });

            await this.notify("error", "ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน");
        } finally {
            this.setState({ isWithdrawLoading: false });
        }
    };
    resetpassword = async (e, type) => {
        e.preventDefault();
        const { phoneNumber, fname, password, oldpassword, passwordcf } = this.state;
        console.log(type, password, oldpassword, passwordcf);
        var token = localStorage.getItem('auth_token');
        if (password === passwordcf) {
            var Username = null;
            var decoded = null;
            if (type === 1 && token != null) {
                decoded = jwt_decode(token);
                Username = decoded.message.playerid;
                instance.post("/api/v1/resetpassword", {
                    username: Username,
                    oldpass: oldpassword,
                    System: Systems,
                    newpass: password,
                    type: type
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 2) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
            else if (type === 3) {
                instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    oldpass: oldpassword,
                    newpass: password,
                    System: Systems,
                    type: type
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        await this.notify("success", 'เปลี่ยนพาสเวิดเรียบร้อย');
                    }
                    else if (res.data.status === 201) {
                        await this.notify("error", 'คุณใส่รหัสเก่าผิดพลาด');
                    }
                    else if (res.data.status === 203) {
                        await this.notify("error", 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง');
                    }
                    else if (res.data.status === 202) {
                        await this.notify("error", 'คุณใช้พาสเวิดเดิม');
                    }
                });
            }
        }
        else {
            await this.notify("error", 'คุณใส่พาสเวิดไม่ตรงกัน');
        }
    }
    async opencliaminvite(evt, cityName) {
        // var str = "ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?\n" +
        //     "คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)\n";
        // Swal.fire({
        //     title: "ยืนยันการถอนโบนัส",
        //     html: '<pre>' + str + '</pre>',
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#81d539",
        //     cancelButtonColor: "#ea133d",
        //     confirmButtonText: "ยืนยัน",
        //     cancelButtonText: "ยกเลิก"
        // }).then(async (result) => {
        console.log(cityName);
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliaminvite", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await this.notify("success", 'ทำรายการรับเงินเรียบร้อย');
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ไม่สามารถทำรายการได้');
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิม '' = รีโหลดหน้าเดิม
                }
            });
        } else {
            await this.notify("error", 'คุณยังไม่ได้ล๊อคอิน');
            return false;
        }
        // });
    }
    handleClick = async (e, price) => {
        console.log(price);
        if (price <= this.state.balance) {
            this.setState({
                withdrawamount: price
            });
        }
        else {
            await this.notify("warning", 'ยอดถอนของท่านไม่เพียงพอในการถอน');
        }
    }
    handleClickreposit = async (e, price) => {
        this.setState({
            depositamount: price
        });
    }
    redeempro = async (e, proid) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //console.log(Username, proid);
        if (token != null) {
            this.setState({
                username: Username,
            });
            await instance.post("/api/v1/redeempromotion", {
                userid: Username,
                System: Systems,
                Proid: proid,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data.status)
                if (res.data.status === 200) {
                    await this.notify("success", 'รับโปรโมชั่นเรียบร้อย โปรดทำการเติมเงิน');
                    this.setState({
                        modalpromotion: false,
                    })
                }
                else if (res.data.status === 201) {
                    await this.notify("error", 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 204) {
                    await this.notify("error", 'ท่านใช้สิทธวันนี้ครบแล้ว');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", 'ท่านมีการรับโปรโมชั่น ค้างไว้');
                    e.preventDefault();
                    this.setState({
                        modalpromotion: false,
                    })
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิม '' = รีโหลดหน้าเดิม
                }
            });
        }
    }
    redeem = async (e, gameIdx, partner) => {
        var userAgent = navigator.userAgent
        await this.checklogin();
        console.log(this.state.loginstate, 55555555)
        if (!this.state.loginstate) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {
            instance.post("/api/v1/tablauncher", {
                gameId: gameIdx,
                partner: partner,
                playerUsername: this.state.username,
                isMobile: isMobile,
                System: Systems,
                demo: false
            })
                .then((res) => {
                    if (res.data.status === 200) {
                        //////console.log(res.data.message);
                        var test = res.data.message.launcher
                        if (test !== undefined) {
                            if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                window.location.href = test.mobile;
                            }
                            else {
                                if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                else window.open(test.mobile);
                            }
                        }
                        else if (test === undefined) {
                            this.notify("error", 'ขณะนี้เกมมีปัญหากรุณารอสักครู่');
                        }
                    }
                    else {
                        //  this.CheckThisGoalError();
                    }
                });
        }
        else {

        }


    }
    redeemcheck = async (e, ListItem) => {
        console.log(ListItem)
        var userAgent = navigator.userAgent
        this.checklogin();
        if (!this.state.loginstate) {
            await this.notify("error", 'คุณยังไม่ได้เข้าสู่ระบบ');
            return;
            //  return document.getElementById("loginmode").click();
        }
        if (this.state.username !== null) {

            if (ListItem.gameId != undefined) {
                instance.post("/api/v1/tablauncher", {
                    gameId: ListItem.gameId,
                    partner: ListItem.partner,
                    playerUsername: this.state.username,
                    isMobile: isMobile,
                    System: Systems,
                    demo: false
                })
                    .then((res) => {
                        if (res.data.status === 200) {
                            //////console.log(res.data.message);
                            var test = res.data.message.launcher
                            if (test !== undefined) {
                                if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                                    window.location.href = test.mobile;
                                }
                                else {
                                    if (!isMobile) window.open(test.desktop, '_blank', 'height=1000,width=1000');
                                    else window.open(test.mobile);
                                }
                            }
                            else if (test === undefined) {
                                this.notify("error", 'ขณะนี้เกมมีปัญหากรุณารอสักครู่');
                            }
                        }
                        else {
                            //  this.CheckThisGoalError();
                        }
                    });
            }
            else {
                this.checkurl(e, "/game/list/" + ListItem.partner)
            }
        }
        else {

        }


    }

    couponredeem = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/usercoupon", {
                User_id: Username,
                System: Systems,
                couponkey: this.state.couponkey,
                type: 1
            }).then(async (res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    await this.notify("success", 'ดำเนินการใช้คูปองเรียบร้อย');
                }
                else {
                    await this.notify("warning", 'ไม่มี Key นี้ในระบบ');
                }
            });
        }
        else {
            await this.notify("warning", 'คุณไม่ได้ล๊อคอิน');
        }

    }

    copy = async (e, accnumber) => {
        toast.success("คัดลอกเรียบร้อย", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });

        navigator.clipboard.writeText(accnumber)
    }
    copyCode = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setTimeout(function () {
                }, 3000);
            })
            .catch((err) => {
                // console.log(err.message);
            });
        this.notify("success", 'คัดลอกสำเร็จ !!');
    };



    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };

    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    async componentDidMount() {

        // [2026-11-04] เดิม setState ทุก 1 วิ ตลอดเวลา (ทั้งหน้า ~4,400 บรรทัด render ใหม่ทุกวินาที = กระตุก) -> อัปเดตเฉพาะตอนมีล็อกถอนเงิน
        this.withdrawTimer = setInterval(() => {
            const lockedUntil = Number(localStorage.getItem("withdrawLockedUntil") || 0);
            const nowTs = Date.now();
            if (!lockedUntil && !this.state.withdrawLockedUntil) return;

            if (lockedUntil && nowTs >= lockedUntil) {
                localStorage.removeItem("withdrawLockedUntil");

                if (this.state.withdrawLockedUntil !== 0 || this.state.nowTs !== nowTs) {
                    this.setState({
                        withdrawLockedUntil: 0,
                        nowTs
                    });
                }
                return;
            }

            if (
                lockedUntil !== this.state.withdrawLockedUntil ||
                Math.floor(nowTs / 1000) !== Math.floor(this.state.nowTs / 1000)
            ) {
                this.setState({
                    withdrawLockedUntil: lockedUntil,
                    nowTs
                });
            }
        }, 1000);


        NProgress.start();
        // [2026-11-04] ไม่ต่อ socket ซ้ำ — App.js ต่อให้ทุกหน้าแล้ว (เดิมต่อ 2 สาย + endpoint เดิมต่อไม่ได้)


        document.body.className = "text-white antialiased bg-gradient-to-b from-bg-f to-bg-t max-w-[414px] mx-auto";
        document.documentElement.className = "scroll-smooth";
        loadAuthCss(() => this.setState({ cssReady: true })); // [2026-11-04] ใช้ไฟล์เดียวกับหน้า login/สมัคร (path จาก root, ไม่แปะซ้ำ) + รอโหลดก่อนแสดง

        this.promotionlist();
        // [2026-11-04] ไม่เรียก checklogin() ตรงนี้ — ด้านล่างเรียก rechecklogin อยู่แล้ว (เดิม checkpoint + ประวัติฝากถอน ยิง 3 รอบทุกครั้งที่เปิดหน้า)
        this.getwheel();
        var token = localStorage.getItem('auth_token');
        var Username = null;
        if (token != null) { try { Username = jwt_decode(token).message.playerid; } catch (e) { Username = null; } }
        try {
            const pathname = window.location.pathname.split("/");
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 30 * 60 * 1000; // 30 นาที

            // ตรวจสอบแคชสำหรับ main setting
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;

                document.title = data.tblsetting[0].title;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);

                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message[1].value,
                    webnamex: data.message[7].value,
                    describemain: data.tblsetting[0].title,
                    System: data.tblcatagoryx[0].System,
                    cashoutSet: data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                });
            } else {
                await instance.post("/api/v1/mainsetting", {
                    System: Systems,
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = res.data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);

                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                        });

                        this.setCache(mainSettingKey, res.data);
                    }
                });
            }

            //   console.log(455, pathname[1] + "/" + pathname[2])
            const getTrueKey = `getTrueCache_${Username}_${Systems}`;
            const getTrueTTL = 30 * 60 * 1000; // 30 นาที
            const getTrueCache = this.getCache(getTrueKey, getTrueTTL);

            if (getTrueCache) {
                console.log("Using cached data for getTrue");
                this.setState({
                    trueaccount: getTrueCache,
                });
            } else if (token && Username) { // [2026-11-04] เดิมเรียกก่อนรู้ token/ยูส (ส่ง undefined ไป -> ไม่สำเร็จ -> ไม่เคยได้แคช ยิงทุกครั้ง)
                await instance.post("/api/v1/gettrue", {
                    userid: Username,
                    System: Systems,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log(res);
                        const trueAccount = res.data.message.tbltruewallet[0];

                        this.setState({
                            trueaccount: trueAccount,
                        });

                        this.setCache(getTrueKey, trueAccount);
                    }
                }).catch((err) => {
                    console.error("Error fetching getTrue data:", err);
                });
            }

            if (pathname.length > 1) {
                console.log(pathname);
                if (pathname[1] == "casino") {
                    this.setState({
                        tabselect: 10,
                    });
                }
                else if (pathname[1] == "gamehit") {

                    this.setState({
                        tabselect: 11,
                    });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({
                        tabselect: 12,
                    });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }
                else if (pathname[1] == "slot") {
                    this.setState({
                        tabselect: 13,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] == "luckywheel") {
                    this.setState({
                        tabselect: 33,
                    });
                }
                else if (pathname[1] == "sport") {
                    this.setState({
                        tabselect: 14,
                    });
                }
                else if (pathname[1] == "event") {
                    this.setState({
                        tabselect: 16,
                    });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    // console.log(1232323)
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 1,
                            tabselectdeposit: 1,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "history") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 3,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "profile") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 8,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    console.log(63855555);
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3]);
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
            try {
                console.log(1625656556);
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    await this.rechecklogin(Username, token);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        firstname: decoded.message.firstname,
                        lastname: decoded.message.lastname,
                        loginstate: true,
                    });
                }
                else {
                    this.setState({
                        loginstate: false,
                    });
                }


            }
            catch (error) {
                console.log(185222, error);
            }
            if (localStorage.getItem('auth_token') == null) this.checklogin(); // ไม่ได้ล็อกอิน -> พาไปหน้า login (เดิมเรียก checkpoint ซ้ำอีกรอบ)
        }
        catch (error) {
            console.log(185222, error);
        }
        if (token != null) {
            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: 50
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(res.data.picture)
                console.log(16888, res.data)
                this.setState({
                    mainacc: res.data.mainacc,
                    listacc: res.data.tblmain,
                    paymentgateway: res.data.tblpaymentgatewayx,
                    paymentlist: res.data.tblpaymentgatewayx,
                });
            });
        }
        NProgress.done();
    }


    async checktab(e, index) {
        console.log(11111, index);
        if (index == 2) {
            //   await this.notify("error", 'ปิดระบบ QRcode ขัวคราว');
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

        }
        else {
            this.setState({
                tabselectdeposit: index,
                tabselect: 1,
            });

            if (index == 3) {
                this.confirmdeposit(e, 0)
            }
        }
    }
    async checkuseradvice(username) {
        instance.post("/api/v1/checkuseradvice", {
            User_id: username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log("statsstatsstatsstats", res.data.message);
                this.setState({
                    stats: res.data.message.stats,
                    reports: res.data.message.reports,
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }
    async rechecklogin(Username, token) {

        try {
            console.log(4555555555555);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {

                if (res.data.status === 200) {
                    console.log(2142, res.data);
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(1067, res.data.userafftoday, res.data.useraffall);
                    var rankall = res.data.tblrankall;
                    const found = rankall.find(obj => {
                        return obj.checked === 1;
                    });
                    this.setState({
                        usercheck: res.data.usercheck,
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        fullname: res.data.message.firstname,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        afficiatetoday: res.data.userafftoday,
                        afficiateall: res.data.useraffall,
                        buttoncliam: (found === undefined) ? true : false,
                        loginstate: true,
                    });

                    this.calllisthistory(Username);
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิมไป selflink ใน BO (โดเมนอื่น + '//login' = หน้าหลัก)
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response?.status === 401 || err.response?.status === 403) {
                    localStorage.clear();
                    await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                    window.location.href = '/login'; // [2026-11-04] เดิมไป selflink ใน BO (โดเมนอื่น + '//login' = หน้าหลัก)
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        console.log(248, proid);
        var Username = "";
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            Username = decoded.message.playerid;
        }
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            console.log(res.data)
            if (res.data.status === 200) {
                //console.log(res.data);
                if (res.data.type === 0) {
                    this.setState({
                        modalpromotion: true,
                        prodetail: res.data.message.tblpromotions[0],
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        modalpromotion: true,
                        proderedeem: res.data.message.tblpromotionredeems,
                    });
                }



            }
            else if (res.data.status === 201) {
                this.setState({
                    showmodal: true,
                    prodetail: [],
                    picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
                });

            }
            else if (res.data.status === 202) {
                await this.notify("success", 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย');
                return false;
            }

        }).catch(async (err) => {
            //   console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                window.location.href = '/login'; // [2026-11-04] เดิมไป selflink ใน BO (โดเมนอื่น + '//login' = หน้าหลัก)
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    async opencliamcashout(evt, cityName) {
        var str = "ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?\n" +
            "คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)\n";
        Swal.fire({
            title: "ยืนยันการถอนโบนัส",
            html: '<pre>' + str + '</pre>',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#81d539",
            cancelButtonColor: "#ea133d",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed) {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);

                    var Username = decoded.message.playerid;
                    await instance.post("/api/v1/cliamcashout", {
                        userid: Username,
                        System: Systems,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            var decoded = jwt_decode(token);
                            var Username = decoded.message.playerid;
                            this.rechecklogin(Username, token);
                            this.notify("success", 'ทำรายการรับเงินเรียบร้อย');

                        }
                        else if (res.data.status === 201) {
                            await this.notify("error", 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน');
                            return false;
                        }
                        else if (res.data.status === 202) {
                            await this.notify("error", 'ไม่สามารถทำรายการได้');
                            return false;
                        }

                    }).catch(async (err) => {
                        // console.log(err);
                        if (err.response.status === 401 || err.response.status === 403) {
                            localStorage.clear();
                            await this.notify("error", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
                            window.location.href = '/login'; // [2026-11-04] เดิมไป selflink ใน BO (โดเมนอื่น + '//login' = หน้าหลัก)
                        }
                    });
                }
                else {
                    await this.notify("error", 'คุณยังไม่ได้ล๊อคอิน');
                }
            }
        });

    }
    render() {
        if (!this.state.cssReady) return <div style={{ minHeight: '100vh', background: '#0f172a' }} />;
        const { activeTab } = this.state;
        const { oldPassword, newPassword, confirmPassword } = this.state;
        let { loginstate, usercheck, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile, limit } = this.state
        const fmtDate = (d) => d ? moment(d).format("DD/MM/YYYY") : "-";
        const cashPeriodStart = moment().startOf('isoWeek').subtract(7, 'days');
        const cashPeriodEnd = moment().startOf('isoWeek').subtract(1, 'days');
        const hasCurrentCashout = false, lastCashout = null;
        // [2026-11-04] ยอดจริงจาก checkpoint (tblmemberlist) + % จากตั้งค่าคืนยอดเสียใน BO — เดิมเขียนตาย 0.00 / 3%
        const _money = (n) => Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const _affCash = Number((tblprofile && tblprofile.AffiliateCash) || 0);
        const _lossCash = Number((tblprofile && tblprofile.Cashtotal) || 0);
        const _cs = this.state.cashoutSet || {};
        const _lossPct = (_cs.percent !== undefined && _cs.percent !== null && _cs.percent !== '') ? Number(_cs.percent) : 5;
        const _friendCount = (this.state.afficiateall || []).length;
        const _btn = (ok) => "bg-gradient-to-br from-button-f to-button-t inline-block text-gray rounded py-1 px-4 font-medium text-sm" + (ok ? "" : " opacity-50 pointer-events-none");
        const { tabselectselect, accnumber, paymentlist, mainacc, trueaccount, listacc, tabselect } = this.state
        var limits = limit
        const paymentArray = Array.isArray(paymentlist) ? paymentlist : (paymentlist ? [paymentlist] : []);


        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        console.log(1326, paymentArray);
        return (
            <>

                <nav className="w-full h-[70px] min-h-[70px] fixed bottom-0 z-50 bg-gradient-to-b from-menu-f to-menu-t max-w-[414px]">
                    <div className="grid grid-cols-5 h-full">
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/home")
                            }}
                            className=" flex flex-col items-center justify-center text-xs gap-1"
                        >
                            <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3 10.25V20C3 20.5523 3.44771 21 4 21H8.42857C8.98086 21 9.42857 20.5523 9.42857 20V13.2857H14.5714V20C14.5714 20.5523 15.0191 21 15.5714 21H20C20.5523 21 21 20.5523 21 20V10.25C21 9.93524 20.8518 9.63885 20.6 9.45L12 3L3.4 9.45C3.14819 9.63885 3 9.93524 3 10.25Z"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <p>หน้าหลัก</p>
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/deposit")
                            }}
                            className=" flex flex-col items-center justify-center text-xs gap-1"
                        >
                            <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.9775 21.4575C15.1425 21.4575 15.285 21.3938 15.405 21.2662C15.525 21.1388 15.585 20.9925 15.585 20.8275V20.2875C16.485 20.1825 17.1938 19.8787 17.7113 19.3763C18.2288 18.8737 18.4875 18.2325 18.4875 17.4525C18.4875 16.6725 18.2738 16.05 17.8463 15.585C17.4188 15.12 16.68 14.715 15.63 14.37C14.685 14.055 14.0363 13.7438 13.6838 13.4363C13.3313 13.1288 13.155 12.7275 13.155 12.2325C13.155 11.7675 13.3237 11.4037 13.6612 11.1413C13.9987 10.8787 14.46 10.7475 15.045 10.7475C15.405 10.7475 15.7275 10.815 16.0125 10.95C16.2975 11.085 16.545 11.2875 16.755 11.5575C16.86 11.6775 16.9875 11.76 17.1375 11.805C17.2875 11.85 17.43 11.835 17.565 11.76C17.73 11.685 17.8387 11.565 17.8912 11.4C17.9437 11.235 17.9175 11.085 17.8125 10.95C17.5575 10.59 17.2463 10.305 16.8787 10.095C16.5112 9.885 16.095 9.7575 15.63 9.7125V9.1725C15.63 9.0075 15.57 8.865 15.45 8.745C15.33 8.625 15.1875 8.565 15.0225 8.565C14.8575 8.565 14.7113 8.625 14.5838 8.745C14.4563 8.865 14.3925 9.0075 14.3925 9.1725V9.7125C13.6275 9.8175 13.0238 10.095 12.5813 10.545C12.1388 10.995 11.9175 11.5575 11.9175 12.2325C11.9175 12.9675 12.1087 13.5525 12.4912 13.9875C12.8737 14.4225 13.5825 14.835 14.6175 15.225C15.6825 15.63 16.3875 15.9825 16.7325 16.2825C17.0775 16.5825 17.25 16.9725 17.25 17.4525C17.25 17.9475 17.0475 18.3637 16.6425 18.7013C16.2375 19.0387 15.7425 19.2075 15.1575 19.2075C14.6625 19.2075 14.2088 19.0875 13.7963 18.8475C13.3838 18.6075 13.065 18.27 12.84 17.835C12.765 17.715 12.6637 17.6213 12.5363 17.5538C12.4088 17.4862 12.2775 17.475 12.1425 17.52C11.9475 17.595 11.8162 17.7113 11.7488 17.8688C11.6813 18.0262 11.7 18.1875 11.805 18.3525C12.105 18.8475 12.4612 19.2487 12.8737 19.5563C13.2863 19.8638 13.7775 20.0925 14.3475 20.2425V20.85C14.3475 21.015 14.4113 21.1575 14.5388 21.2775C14.6663 21.3975 14.8125 21.4575 14.9775 21.4575ZM15 24C13.725 24 12.54 23.7712 11.445 23.3137C10.35 22.8562 9.3975 22.2225 8.5875 21.4125C7.7775 20.6025 7.14375 19.65 6.68625 18.555C6.22875 17.46 6 16.275 6 15C6 13.74 6.22875 12.5625 6.68625 11.4675C7.14375 10.3725 7.7775 9.42 8.5875 8.61C9.3975 7.8 10.35 7.1625 11.445 6.6975C12.54 6.2325 13.725 6 15 6C16.26 6 17.4375 6.2325 18.5325 6.6975C19.6275 7.1625 20.58 7.8 21.39 8.61C22.2 9.42 22.8375 10.3725 23.3025 11.4675C23.7675 12.5625 24 13.74 24 15C24 16.275 23.7675 17.46 23.3025 18.555C22.8375 19.65 22.2 20.6025 21.39 21.4125C20.58 22.2225 19.6275 22.8562 18.5325 23.3137C17.4375 23.7712 16.26 24 15 24ZM15 22.65C17.175 22.65 18.9937 21.9187 20.4563 20.4563C21.9187 18.9937 22.65 17.175 22.65 15C22.65 12.825 21.9187 11.0063 20.4563 9.54375C18.9937 8.08125 17.175 7.35 15 7.35C12.825 7.35 11.0063 8.08125 9.54375 9.54375C8.08125 11.0063 7.35 12.825 7.35 15C7.35 17.175 8.08125 18.9937 9.54375 20.4563C11.0063 21.9187 12.825 22.65 15 22.65Z"
                                    fill="white"
                                    stroke="currentColor"
                                    strokeWidth="0.6"
                                />
                                <path
                                    d="M4.54056 9.54546C4.48178 9.54546 4.42055 9.53287 4.35688 9.5077C4.2932 9.48253 4.23687 9.44477 4.18789 9.39442L0.146944 5.24094C0.0489812 5.14025 0 5.01942 0 4.87845C0 4.73749 0.0489812 4.61666 0.146944 4.51597C0.254702 4.41528 0.374706 4.36493 0.506955 4.36493C0.639205 4.36493 0.75431 4.41528 0.852273 4.51597L4.04095 7.79345V0.513522C4.04095 0.372555 4.08993 0.251726 4.18789 0.151036C4.28585 0.0503454 4.40341 0 4.54056 0C4.6875 0 4.8075 0.0503454 4.90057 0.151036C4.99363 0.251726 5.04017 0.372555 5.04017 0.513522V7.79345L8.22884 4.51597C8.3268 4.41528 8.44191 4.36493 8.57416 4.36493C8.70641 4.36493 8.82641 4.41528 8.93417 4.51597C9.03213 4.61666 9.08111 4.73749 9.08111 4.87845C9.08111 5.01942 9.03213 5.14025 8.93417 5.24094L4.89322 9.39442C4.83444 9.44477 4.77812 9.48253 4.72424 9.5077C4.67036 9.53287 4.60913 9.54546 4.54056 9.54546Z"
                                    fill="white"
                                    stroke="currentColor"
                                    strokeWidth="0.6"
                                />
                            </svg>
                            <p>ฝากเงิน</p>
                        </a>
                        <a
                            role="button"
                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                            target="_blank"
                            className="flex items-center justify-center   mx-auto -mt-[30px]"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/7b597183-4daa-497a-9fce-2adf488f090b.png"
                                width={92}
                                height={31}
                            />
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/afficiate")
                            }}
                            className=" flex flex-col items-center justify-center text-xs gap-1"
                        >
                            <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M23.8557 19.3326L20.3679 14.5627C19.5994 13.5115 18.4493 12.8115 17.204 12.6119C18.0128 11.4114 18.4467 9.99972 18.4467 8.51191C18.4467 4.44952 15.1417 1.14453 11.0793 1.14453C7.01696 1.14453 3.71197 4.44952 3.71197 8.51191C3.71197 9.93503 4.11867 11.3164 4.88815 12.5067C5.56045 13.5466 6.47883 14.396 7.55978 14.9843C7.75958 15.7933 8.48824 16.4005 9.34567 16.4196L13.7463 16.5174C13.8606 16.5199 13.9325 16.5817 13.9651 16.6184C13.9978 16.655 14.051 16.7335 14.0403 16.8474C14.0259 17.0019 13.8943 17.1214 13.7396 17.1214L13.7349 17.1213L8.67921 17.0429C8.40049 17.0385 8.1284 16.9386 7.91312 16.7615L3.43639 13.079C2.5818 12.3759 1.32086 12.4589 0.565603 13.2676C0.181361 13.6791 -0.0189955 14.2155 0.00141952 14.7782C0.0218346 15.3408 0.260626 15.8613 0.673818 16.2438L6.36497 21.5129C7.06897 22.1646 7.98465 22.5412 8.94346 22.5732L17.3958 22.8554C17.4044 22.8557 17.4128 22.8558 17.4213 22.8558C17.8232 22.8558 18.1556 22.5368 18.1691 22.1321C18.1829 21.7188 17.8591 21.3726 17.4458 21.3588L8.99347 21.0766C8.3944 21.0566 7.82218 20.8213 7.38233 20.4141L1.69123 15.1451C1.57248 15.0352 1.50385 14.8856 1.49796 14.7239C1.49207 14.5622 1.54967 14.408 1.66013 14.2898C1.87716 14.0574 2.23959 14.0336 2.48517 14.2355L6.9619 17.9181C7.43804 18.3097 8.0397 18.5306 8.656 18.5402L13.7117 18.6187C13.721 18.6188 13.7302 18.6189 13.7395 18.6189C14.6612 18.6188 15.4456 17.9069 15.5314 16.9864C15.5775 16.491 15.4142 15.9938 15.0832 15.6223C14.7522 15.2509 14.2771 15.0315 13.7796 15.0204L9.37896 14.9226C9.1803 14.9181 9.01528 14.7593 9.0034 14.561C8.99482 14.418 9.0637 14.3211 9.10548 14.2761C9.14726 14.2311 9.23875 14.1552 9.38191 14.1531L16.4116 14.0509C16.4476 14.0504 16.4833 14.0505 16.5189 14.0509C17.5445 14.0664 18.5315 14.5881 19.1592 15.4465L22.6469 20.2165C22.891 20.5503 23.3595 20.6231 23.6932 20.379C24.027 20.1349 24.0998 19.6665 23.8557 19.3326ZM9.36009 12.6558C8.84867 12.6632 8.35581 12.8825 8.00791 13.2574C7.95794 13.3112 7.91182 13.368 7.86885 13.427C7.18277 12.9784 6.59538 12.3894 6.1457 11.6939C5.53315 10.7463 5.2094 9.64607 5.2094 8.51201C5.2094 5.27531 7.84264 2.64207 11.0793 2.64207C14.3161 2.64207 16.9493 5.27531 16.9493 8.51201C16.9493 10.0427 16.3731 11.4725 15.321 12.5692L11.5783 12.6236V12.3517C12.5508 12.125 13.2776 11.2516 13.2776 10.2112C13.2776 9.17064 12.5508 8.29728 11.5783 8.07057V5.72169C11.9915 5.91152 12.2793 6.329 12.2793 6.81262C12.2793 7.08825 12.5028 7.31177 12.7784 7.31177C13.0541 7.31177 13.2776 7.08825 13.2776 6.81262C13.2776 5.77216 12.5508 4.8988 11.5783 4.67209V4.32608C11.5783 4.05046 11.3549 3.82694 11.0792 3.82694C10.8035 3.82694 10.5801 4.05046 10.5801 4.32608V4.67209C9.60762 4.8988 8.88081 5.77216 8.88081 6.81262C8.88081 7.85309 9.60762 8.7264 10.5801 8.95316V11.3021C10.1669 11.1123 9.8791 10.6948 9.8791 10.2112C9.8791 9.93553 9.65564 9.71201 9.37996 9.71201C9.10428 9.71201 8.88081 9.93553 8.88081 10.2112C8.88081 11.2516 9.60762 12.1249 10.5801 12.3517V12.6381L9.36009 12.6558ZM10.5801 7.90351C10.1669 7.71373 9.8791 7.29625 9.8791 6.81257C9.8791 6.32895 10.1669 5.91147 10.5801 5.72164V7.90351ZM11.5783 9.12012C11.9915 9.30995 12.2793 9.72743 12.2793 10.2111C12.2793 10.6948 11.9915 11.1123 11.5783 11.302V9.12012Z"
                                    fill="white"
                                    stroke="currentColor"
                                    strokeWidth="0.5"
                                />
                            </svg>
                            <p>รายได้</p>
                        </a>
                        <a
                            href={this.state.linelink}
                            className=" flex flex-col items-center justify-center text-xs gap-1"
                        >
                            <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.521 11.3916H20.3684C20.1836 6.73295 16.337 3 11.6342 3C6.93138 3 3.08479 6.73295 2.89991 11.3916H2.78671C2.57806 11.3916 2.37796 11.4745 2.23042 11.622C2.08289 11.7696 2 11.9697 2 12.1783V16.8986C2 17.1072 2.08289 17.3073 2.23042 17.4549C2.37796 17.6024 2.57806 17.6853 2.78671 17.6853H3.84484C3.93197 18.4542 4.29891 19.1642 4.87576 19.6801C5.4526 20.1959 6.19905 20.4815 6.9729 20.4825H9.42045V20.7557C9.42045 20.8484 9.45729 20.9373 9.52286 21.0029C9.58843 21.0685 9.67737 21.1053 9.7701 21.1053H11.635C11.7278 21.1053 11.8167 21.0685 11.8823 21.0029C11.9479 20.9373 11.9847 20.8484 11.9847 20.7557V19.5092C11.9847 19.4164 11.9479 19.3275 11.8823 19.2619C11.8167 19.1964 11.7278 19.1595 11.635 19.1595H9.76923C9.67649 19.1595 9.58756 19.1964 9.52199 19.2619C9.45641 19.3275 9.41958 19.4164 9.41958 19.5092V19.7836H6.97202C6.38354 19.783 5.81492 19.5707 5.36999 19.1855C4.92505 18.8004 4.63348 18.2681 4.54851 17.6857H5.64117C5.74448 17.6857 5.84678 17.6654 5.94223 17.6259C6.03768 17.5863 6.12441 17.5284 6.19746 17.4553C6.27051 17.3823 6.32846 17.2955 6.368 17.2001C6.40753 17.1046 6.42788 17.0023 6.42788 16.899V12.1788C6.42788 11.9701 6.345 11.77 6.19746 11.6225C6.04992 11.4749 5.84982 11.392 5.64117 11.392H5.46634C5.64904 8.14816 8.34528 5.56468 11.6342 5.56468C14.9231 5.56468 17.6219 8.14816 17.802 11.3925H17.6656C17.457 11.3925 17.2569 11.4754 17.1093 11.6229C16.9618 11.7704 16.8789 11.9705 16.8789 12.1792V16.8995C16.8789 17.1081 16.9618 17.3082 17.1093 17.4558C17.2569 17.6033 17.457 17.6862 17.6656 17.6862H20.521C20.7296 17.6862 20.9297 17.6033 21.0773 17.4558C21.2248 17.3082 21.3077 17.1081 21.3077 16.8995V12.1792C21.3078 12.0758 21.2875 11.9734 21.248 11.8779C21.2086 11.7823 21.1506 11.6955 21.0776 11.6223C21.0045 11.5492 20.9177 11.4912 20.8222 11.4516C20.7267 11.412 20.6244 11.3916 20.521 11.3916ZM10.1189 19.8588H11.2845V20.4065H10.1189V19.8588ZM5.72946 12.1779V16.8982C5.72946 16.9213 5.72025 16.9436 5.70385 16.96C5.68746 16.9764 5.66523 16.9856 5.64204 16.9856H2.78671C2.76353 16.9856 2.7413 16.9764 2.7249 16.96C2.70851 16.9436 2.6993 16.9213 2.6993 16.8982V12.1779C2.6993 12.1547 2.70851 12.1325 2.7249 12.1161C2.7413 12.0997 2.76353 12.0905 2.78671 12.0905H5.64204C5.66523 12.0905 5.68746 12.0997 5.70385 12.1161C5.72025 12.1325 5.72946 12.1547 5.72946 12.1779ZM11.6342 4.86451C7.95979 4.86451 4.94711 7.76136 4.76573 11.3912H3.60009C3.78409 7.11844 7.3173 3.69886 11.6342 3.69886C15.951 3.69886 19.4843 7.11844 19.6683 11.3912H18.5026C18.3195 7.76136 15.3086 4.86451 11.6342 4.86451ZM20.6084 16.8986C20.6084 16.9218 20.5992 16.944 20.5828 16.9604C20.5664 16.9768 20.5441 16.986 20.521 16.986H17.6656C17.6425 16.986 17.6202 16.9768 17.6038 16.9604C17.5874 16.944 17.5782 16.9218 17.5782 16.8986V12.1783C17.5782 12.1551 17.5874 12.1329 17.6038 12.1165C17.6202 12.1001 17.6425 12.0909 17.6656 12.0909H20.521C20.5441 12.0909 20.5664 12.1001 20.5828 12.1165C20.5992 12.1329 20.6084 12.1551 20.6084 12.1783V16.8986Z"
                                    fill="white"
                                    stroke="currentColor"
                                    strokeWidth="0.6"
                                />
                            </svg>
                            <p>ติดต่อเรา</p>
                        </a>
                    </div>
                </nav>
                <main className="min-h-screen bg-ufo-1 bg-no-repeat bg-[center_top_200px] p-4 pb-32 overflow-hidden">
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center justify-between">
                            <a role="button" onClick={(e) => {
                                this.checkurl(e, "/")
                            }}>
                                <div className="flex justify-center items-center rounded-md font-bold text-xl w-24 h-10">
                                    <img
                                        src={this.state.logoimg}
                                        style={{ width: 400 }}
                                    />
                                </div>
                            </a>
                            <div className="flex items-center gap-2">
                                <div className="flex flex-col items-end">
                                    <div className="inline-flex items-center gap-1 text-base font-medium">
                                        <img loading="lazy" decoding="async"
                                            src={require("./assets/member-appufa/icons/user-fill.svg").default}
                                            alt="user"
                                        />
                                        {firstname}
                                    </div>
                                    <p className="text-sm text-gray leading-none bankNumber">
                                        {username}
                                    </p>
                                    <p className="text-sm text-gray leading-none ">ยูส : {usercheck}</p>
                                </div>
                                <a
                                    href="/logout"
                                    className="rounded-full w-8 h-8 flex items-center justify-center bg-input"
                                >
                                    <img
                                        src={require("./assets/member-appufa/icons/logout.svg").default}
                                        alt="logout"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40 p-4 !rounded-md to-50%">
                            <div className="flex items-start justify-between">
                                <img loading="lazy" decoding="async"
                                    src={require("./assets/member-appufa/icons/wallet.svg").default}
                                    alt="wallet"
                                    className="w-[70px] h-[70px] -ml-2 -mt-2 drop-shadow-[0_0_10px_white]"
                                />
                                <div className="text-end">
                                    <div className="inline-flex items-center gap-1 text-xs font-normal">
                                        <img loading="lazy" decoding="async"
                                            src={require("./assets/member-appufa/icons/money.svg").default}
                                            alt="money"
                                            className="w-4 h-4"
                                        />
                                        ยอดเงินปัจจุบัน
                                    </div>
                                    <div className="text-xl text-highlight font-normal" id="balance">
                                        {balance} บาท
                                    </div>
                                    {/* <a
                                        href="#"
                                        onclick="cashout()"
                                        className="flex items-center justify-center w-fit bg-input float-right px-2 gap-1 mt-1 rounded text-xs text-gray"
                                    >
                                        <img loading="lazy" decoding="async"
                                            className="refresh"
                                            src={require("./assets/member-appufa/icons/refresh.svg").default}
                                            alt="โยกเงิน"
                                        />
                                        <svg
                                            style={{ display: "none" }}
                                            aria-hidden="true"
                                            role="status"
                                            className="loading_spiner inline w-4 h-4  text-white animate-spin"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="yellow"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                        โยกเงิน
                                    </a> */}
                                </div>
                            </div>
                            <hr className="my-4 border-white/20" />
                            <div className="grid grid-cols-2 gap-4">
                                <a
                                    role="button" onClick={(e) => {
                                        this.checkurl(e, "/loss")
                                    }}
                                    className="bg-gradient-to-br from-button-f to-button-t flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium"
                                >
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/friend.svg").default}
                                        alt="friend"
                                    />
                                    แนะนำเพื่อน
                                </a>
                                <a
                                    role="button" onClick={(e) => {
                                        this.checkurl(e, "/afficiate")
                                    }}
                                    className="bg-[#061537] flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium"
                                >
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/return.svg").default}
                                        alt="return"
                                    />
                                    รายได้
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-3 grid-rows-2 gap-4 my-6" style={{ display: tabselect == 0 ? "" : "none" }}>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/deposit")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/add.svg").default}
                                alt="ฝากเงิน"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            ฝากเงิน
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/withdraw")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/remove.svg").default}
                                alt="ถอนเงิน"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            ถอนเงิน
                        </a>
                        <a
                            role='button'
                            style={{ paddingTop: "20px !important" }}
                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                            target="_blank"
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/game.svg").default}
                                alt="เล่นเกม"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            เล่นเกม
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/history")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/history.svg").default}
                                alt="ประวัติ"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            ประวัติ
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/profile")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/user.svg").default}
                                alt="บัญชี"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            บัญชี
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/promotion")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://img.icons8.com/ios/50/FFFFFF/commercial--v1.png"
                                alt="โปรโมชั่น"
                                height={42}
                                width={42}
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            โปรโมชั่น
                        </a>
                        <a
                            role="button" onClick={(e) => {
                                // [2026-11-04] เดิมไปหน้า "รายได้แนะนำเพื่อน" -> ไปการ์ดคืนยอดเสียในหน้าหลัก
                                this.checkurl(e, "/home");
                                setTimeout(() => { const el = document.getElementById('zb-cashback'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 350);
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://img.icons8.com/ios/50/FFFFFF/refund.png"
                                alt="คืนยอดเสีย"
                                height={42}
                                width={42}
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />

                            คืนยอดเสีย
                        </a>

                        <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/uploadslip")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1 w-10 h-10"
                            >
                                <path
                                    d="M12 2L6 8h4v6h4V8h4l-6-6zM5 20a2 2 0 0 1-2-2v-6h2v6h14v-6h2v6a2 2 0 0 1-2 2H5zm4-2h6v-2H9v2z"
                                />
                            </svg>
                            อัพโหลด Slip
                        </a>
                        <a
                            href={this.state.linelink}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src={require("./assets/member-appufa/icons/home_menu/contact.svg").default}
                                alt="ติดต่อเรา"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            ติดต่อเรา
                        </a>
                        {/* <a
                            role="button" onClick={(e) => {
                                this.checkurl(e, "/luckywheel")
                            }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://img.icons8.com/color/48/color-wheel-2.png"
                                alt="กงล้อ"
                                height={42}
                                width={42}
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            กงล้อ
                        </a> */}
                        {/* <a role="button" onClick={(e) => {
                            this.checkurl(e, "/checkindaily")
                        }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/a9e16dba-6407-4c01-850f-0a6061eefd22.png"
                                alt="เช็คอิน"
                                height={42}
                                width={42}
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            เช็คอิน
                        </a> */}
                        <a role="button" onClick={(e) => {
                            this.checkurl(e, "/ulive")
                        }}
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/bc99896e-8f43-4d62-9708-51c5084bcaad.png"
                                alt="Ulive"
                                style={{ width: 50 }}
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            Ulive
                        </a>
                        <a
                            role='button'
                            style={{ paddingTop: "20px !important" }}
                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                            target="_blank"
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/7b597183-4daa-497a-9fce-2adf488f090b.png"
                                style={{ width: 50 }}
                                alt="เล่นเกม"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            เข้าเล่นสำรอง 1
                        </a>
                        <a
                            role='button'
                            style={{ paddingTop: "20px !important" }}
                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                            target="_blank"
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/7b597183-4daa-497a-9fce-2adf488f090b.png"
                                style={{ width: 50 }}
                                alt="เล่นเกม"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            เข้าเล่นสำรอง 2
                        </a>
                        <a
                            role='button'
                            style={{ paddingTop: "20px !important" }}
                            onClick={(e) => this.redeem(e, "sport", "uefa")}
                            target="_blank"
                            className="font-medium text-sm w-fit flex flex-col mx-auto items-center justify-center gap-2"
                        >
                            <img loading="lazy" decoding="async"
                                src="https://cdn.javisx.com/image/7b597183-4daa-497a-9fce-2adf488f090b.png"
                                style={{ width: 50 }}
                                alt="เล่นเกม"
                                className="bg-gradient-to-b from-menu-f to-menu-t border border-highlight rounded-full p-1"
                            />
                            เข้าเล่นสำรอง 3
                        </a>
                    </div>
                    <div style={{ display: tabselect == 3 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            ประวัติการฝากเงิน-ถอนเงิน
                        </h1>
                        <ul className="grid grid-cols-2 gap-2" id="tabs-history" role="tablist">
                            <li role="presentation">
                                <button
                                    className={`w-full text-sm rounded py-2 px-4 font-medium ${activeTab === 'deposit-history'
                                        ? 'bg-gradient-to-br from-button-f to-button-t text-gray'
                                        : 'bg-[#061537] text-gray'
                                        }`}
                                    id="deposit-history-tab"
                                    type="button"
                                    role="tab"
                                    aria-controls="deposit-history"
                                    aria-selected="true"
                                    onClick={() => this.handleTabChange('deposit-history')}
                                >
                                    ฝากเงิน
                                </button>
                            </li>
                            <li role="presentation">
                                <button
                                    className={`w-full text-sm rounded py-2 px-4 font-medium ${activeTab === 'withdraw-history'
                                        ? 'bg-gradient-to-br from-button-f to-button-t text-gray'
                                        : 'bg-[#061537] text-gray'
                                        }`}
                                    id="withdraw-history-tab"
                                    type="button"
                                    role="tab"
                                    onClick={() => this.handleTabChange('withdraw-history')}
                                    aria-controls="withdraw-history"
                                    aria-selected="false"
                                >
                                    ถอนเงิน
                                </button>
                            </li>
                        </ul>
                        <div
                            className={activeTab === 'deposit-history' ? 'mt-4' : 'mt-4 hidden'}
                            id="deposit-history"
                            role="tabpanel"
                            aria-labelledby="deposit-history-tab"
                        >
                            <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] pb-0 bg-card">
                                <div
                                    id="deposit-month"
                                    className="text-center border-none rounded-[4px] bg-card block py-1 pl-2 !pr-7 ml-auto text-xs focus:border-none focus:ring-0"
                                >
                                    ประจำเดือน : ทั้งหมด
                                </div>
                                <div className="divide-y divide-white/20 max-h-[500px] overflow-y-scroll overflow-x-hidden">
                                    <div className="space-y-2 py-4 first:pt-2" id="transaction-deposti-list">
                                        {this.state.historylist.filter(
                                            (listitem) =>
                                                listitem.type === "DE" || listitem.type === "BN" // เงื่อนไขกรอง
                                        ).map((listitem, i) => (
                                            <div className="rounded-md border border-[#62D38F]/20 p-2.5 flex items-center justify-between text-sm">
                                                <div className="flex items-center gap-2">
                                                    <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>

                                                        <img loading="lazy" decoding="async"
                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                            className="-ic"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>

                                                        <img loading="lazy" decoding="async"
                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                            className="-ic"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>

                                                        <img loading="lazy" decoding="async"
                                                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                            className="-ic"
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="w-full text-start text-gray space-y-0">
                                                        <div className="text-white">{(listitem.type === "DE") ? "ฝากเงิน" : "โบนัส"}
                                                            <div className="-state-wrapper" style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                                                <span className="-state-text">สถานะ : </span>
                                                                <i className="fas fa-spinner fa-spin"></i>
                                                                <span className="-state-title">กำลังดำเนินการ</span>
                                                                <span className="-state-title -short">กำลังดำเนินการ</span>
                                                            </div>
                                                            <div className="-state-wrapper" style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                                                <span className="-state-text">สถานะ : </span>
                                                                <i className="fas fa-spinner fa-spin"></i>
                                                                <span className="-state-title">รอดำเนินการ</span>

                                                            </div>
                                                            <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                                                <span className="-state-text">สถานะ : </span>
                                                                <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                            </div>
                                                            <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                                                <span className="-state-text">สถานะ : </span>
                                                                <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                            </div>
                                                            <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                                                <span className="-state-text">สถานะ : </span>
                                                                <span className="-state-title">สำเร็จ</span>
                                                            </div>
                                                        </div>
                                                        <div className="text-xs text-gray">
                                                            วันที่ : {moment(listitem.createdate).format('DD/MM/YY') + " เวลา : " + moment(listitem.createdate).format('HH:mm') + " น."}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="text-green">+ {listitem.amount.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </div> */}
                                                <div className={(listitem.type === "DE") ? "-amount -deposit" : "-amount -bonus"}>{Number(listitem.amount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} บาท</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={activeTab === 'withdraw-history' ? 'mt-4' : 'mt-4 hidden'}
                            id="withdraw-history"
                            role="tabpanel"
                            aria-labelledby="withdraw-history-tab"
                        >
                            <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] pb-0 bg-card">
                                <div
                                    id="withdraw-month"
                                    className="text-center border-none rounded-[4px] bg-card block py-1 pl-2 !pr-7 ml-auto text-xs focus:border-none focus:ring-0"
                                >
                                    ประจำเดือน : ทั้งหมด
                                </div>
                                <div className="divide-y divide-white/20 max-h-[500px] overflow-y-scroll overflow-x-hidden">
                                    <div className="divide-y divide-white/20 max-h-[500px] overflow-y-scroll overflow-x-hidden">
                                        <div className="space-y-2 py-4 first:pt-2" id="transaction-deposti-list">
                                            {this.state.historylist.filter(
                                                (listitem) =>
                                                    listitem.type === "WD" // เงื่อนไขกรอง
                                            ).map((listitem, i) => (
                                                <div className="rounded-md border border-[#62D38F]/20 p-2.5 flex items-center justify-between text-sm">
                                                    <div className="flex items-center gap-2">
                                                        <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>

                                                            <img loading="lazy" decoding="async"
                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                className="-ic"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>

                                                            <img loading="lazy" decoding="async"
                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                className="-ic"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>

                                                            <img loading="lazy" decoding="async"
                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                className="-ic"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="w-full text-start text-gray space-y-0">
                                                            <div className="text-white">{(listitem.type === "DE") ? "ฝากเงิน" : "โบนัส"}
                                                                <div className="-state-wrapper" style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                                                    <span className="-state-text">สถานะ : </span>
                                                                    <i className="fas fa-spinner fa-spin"></i>
                                                                    <span className="-state-title">กำลังดำเนินการ</span>
                                                                    <span className="-state-title -short">กำลังดำเนินการ</span>
                                                                </div>
                                                                <div className="-state-wrapper" style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                                                    <span className="-state-text">สถานะ : </span>
                                                                    <i className="fas fa-spinner fa-spin"></i>
                                                                    <span className="-state-title">รอดำเนินการ</span>

                                                                </div>
                                                                <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                                                    <span className="-state-text">สถานะ : </span>
                                                                    <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                                </div>
                                                                <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                                                    <span className="-state-text">สถานะ : </span>
                                                                    <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                                </div>
                                                                <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                                                    <span className="-state-text">สถานะ : </span>
                                                                    <span className="-state-title">สำเร็จ</span>
                                                                </div>
                                                            </div>
                                                            <div className="text-xs text-gray">
                                                                วันที่ : {moment(listitem.createdate).format('DD/MM/YY') + " เวลา : " + moment(listitem.createdate).format('HH:mm') + " น."}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="text-green">+ {listitem.amount.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </div> */}
                                                    <div className="-amount -withdraw">{Number(listitem.amount).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} บาท</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: tabselect == 1 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            ฝากเงิน
                        </h1>
                        <div id="_accordion" className="flex flex-col gap-4">
                            {mainacc !== null && (
                                <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40">
                                    <button
                                        type="button"
                                        id="_deposit_1"
                                        className="flex items-center justify-between w-full gap-2 px-4 py-3"
                                        onClick={() => this.toggleAccordion('panel-1')}
                                        aria-expanded={this.state.openAccordion === 'panel-1'}
                                        aria-controls="_doposit_body_1"
                                    >
                                        <span className="inline-flex gap-2 items-center">
                                            <img loading="lazy" decoding="async"
                                                src={accnumber && accnumberx?.accbank == 99 ? require("./assets/member-appufa/icons/deposit-truewallet.png").default : require("./assets/member-appufa/icons/deposit-bank.png").default}
                                                alt="bank"
                                                className="w-8 h-8"
                                            />
                                            {accnumber && accnumberx?.accbank == 99 ? "ทรูวอลเลท" : "ธนาคาร"}
                                        </span>
                                        <svg className={`w-5 h-5 shrink-0 transform transition-transform duration-200 ${this.state.openAccordion === 'panel-1' ? 'rotate-180' : 'rotate-0'}`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.99983 9.76936L5.06396 6.8335H10.9357L7.99983 9.76936Z" fill="white" />
                                        </svg>
                                    </button>

                                    <div
                                        id="_doposit_body_1"
                                        className={`${this.state.openAccordion === 'panel-1' ? 'block' : 'hidden'} space-y-2 p-4 pt-1`}
                                        aria-labelledby="_deposit_1"
                                    >
                                        {/* content เดิมของคุณ (รายการบัญชี ฯลฯ) */}
                                        {listacc && listacc.length > 0 ? (
                                            listacc
                                                .filter(listitem => {
                                                    if (accnumber !== null) {
                                                        if (accnumberx?.accbank === 99) {
                                                            return listitem.bankid === 99;
                                                        }
                                                        return listitem.bankid !== 99;
                                                    }
                                                    return false;
                                                })
                                                .map((listitem, i) => (
                                                    <div key={i} className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] flex items-center justify-between">
                                                        <div className="flex items-center gap-4">
                                                            <img loading="lazy" decoding="async" src={listitem?.img_path} alt={listitem?.img_path} className="w-[50px] h-[50px]" />
                                                            <div className="w-full text-start text-sm text-gray space-y-0">
                                                                <div className="text-white">{listitem?.fullname_th}</div>
                                                                <div className="bank_no">
                                                                    {listitem?.accnumber
                                                                        ? listitem.accnumber.substring(0, 3) + "-" + listitem.accnumber.substring(3, 9) + "-" + listitem.accnumber.substring(9, 12)
                                                                        : "No Account Number"}
                                                                </div>
                                                                <div>{listitem?.first_name_en + " " + listitem?.last_name_en}</div>
                                                            </div>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="copy-bankno text-highlight text-xs inline-flex items-center gap-1"
                                                            onClick={() => this.copyCode(listitem?.accnumber)}
                                                        >
                                                            <img loading="lazy" decoding="async" src={require("./assets/member-appufa/icons/copy.svg").default} alt="copy" className="w-3.5 h-3.5" />
                                                            คัดลอก
                                                        </button>
                                                    </div>
                                                ))
                                        ) : (
                                            <div>ไม่พบรายการบัญชี</div>
                                        )}

                                        {/* ข้อมูลผู้ใช้อื่น ๆ */}
                                        <div>
                                            <h2 className="text-base text-highlight mb-2">กรุณาโอนจากบัญชีที่ลงทะเบียนเท่านั้น!!</h2>
                                            <div className="grid grid-cols-2 gap-2 text-sm text-gray">
                                                <h3>ชื่อบัญชี</h3>
                                                <div className="text-right text-white">{firstname}</div>
                                                <h3>เลขบัญชี</h3>
                                                <div className="text-right text-white bank_no">
                                                    {accnumber
                                                        ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12)
                                                        : "No Account Number"}
                                                </div>
                                                <h3>ธนาคาร</h3>
                                                <div className="text-right text-white inline-flex items-center justify-end gap-1">
                                                    <img loading="lazy" decoding="async" src={accnumber !== null ? accnumberx.img_path : ""} alt="ธนาคาร" className="w-4 h-4" />
                                                    {accnumber !== null ? accnumberx.fullname_th : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ตัวอย่าง panel Payment Gateway (panel-3) */}
                            {mainacc !== null && accnumberx?.accbank !== 99 && paymentArray.length > 0 && (
                                <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40">
                                    <button
                                        type="button"
                                        id="_deposit_pg"
                                        className="flex items-center justify-between w-full gap-2 px-4 py-3"
                                        onClick={() => this.toggleAccordion('panel-3')}
                                        aria-expanded={this.state.openAccordion === 'panel-3'}
                                        aria-controls="_doposit_body_3"
                                    >
                                        <span className="inline-flex gap-2 items-center">
                                            <img loading="lazy" decoding="async" src={require("./assets/member-appufa/icons/deposit-bank.png").default} alt="bank" className="w-8 h-8" />
                                            Payment Gateway
                                        </span>
                                        <svg className={`w-5 h-5 shrink-0 transform transition-transform duration-200 ${this.state.openAccordion === 'panel-3' ? 'rotate-180' : 'rotate-0'}`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.99983 9.76936L5.06396 6.8335H10.9357L7.99983 9.76936Z" fill="white" />
                                        </svg>
                                    </button>

                                    <div id="_doposit_body_3" className={`${this.state.openAccordion === 'panel-3' ? 'block' : 'hidden'} space-y-2 p-4 pt-1`}>
                                        <div className="animated animatedFadeInUp fadeInUp " style={{ display: this.state.qrcodecheck ? "none" : "" }}>
                                            <div className="card-promptpay text-center pt-3" >
                                                <img
                                                    className="img-logo-promptpay"
                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9c9ef88c-a34b-4aa6-1a42-54ff6cd9a800/public"
                                                    alt=""
                                                />
                                                <span className="">พร้อมเพย์ / ธนาคารเท่านั้น</span>
                                                <div className="pt-3 pb-2 text-left p-detail-promptpay "  >
                                                    <div className="pt-2 pb-2">
                                                        <small className="p">ระบุจำนวนเงินที่ต้องเติม *ขั้นต่ำ 300 บาท</small>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        id="depositamount"
                                                        onChange={this.onChangexdep}
                                                        value={this.state.depositamount}
                                                        placeholder="กรอกจำนวนเงิน"
                                                        maxLength={4}
                                                        minLength={4}
                                                        name="number"
                                                        className="border border-highlight/60 rounded-xl bg-input block w-full p-2.5 text-center text-lg focus:border-highlight/60"
                                                    />
                                                    <div className="pt-2 pb-2 parent-div " >
                                                        <button className="bg-gradient-to-br from-button-f to-button-t flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium"
                                                            onClick={(e) => this.confirmdeposit(e, 0, 1)}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={16}
                                                                height={16}
                                                                fill="currentColor"
                                                                className="bi bi-check-circle-fill"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                            </svg>{" "}
                                                            สร้าง QR Code เพื่อชำระ
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="animated animatedFadeInUp fadeInUp " style={{ display: !this.state.qrcodecheck ? "none" : "" }}>
                                            <div className="card-promptpay text-center pt-3">
                                                <div className="card-body-promptpay">
                                                    <div className="card card-2-promptpay">
                                                        <div className="card-header card-2-promptpay-header">
                                                            {" "}
                                                            QR Code สำหรับชำระเงิน
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="p-2 mb-2 bg-success-subtle">
                                                                <small className="text">
                                                                    QR Code
                                                                    สามารถสเเกนจ่ายได้เพียงครั้งเดี่ยวเท่านั้นโปรดอย่าสเเกนจ่ายซ้ำ
                                                                </small>
                                                            </div>
                                                            <h6 className="mb-2 mt-2 text-center">
                                                                <u>โอนเข้าบัญชี * ขั้นต่ำ 100 บาท</u>
                                                            </h6>
                                                            <div className="prt-2">
                                                                <div className="img-qr-code">
                                                                    {this.state.qrcode !== null ?
                                                                        <img
                                                                            src={this.state.qrcode}
                                                                            className="-img-text-promotion img-fluid ls-is-cached lazyloaded img-logo-qr"
                                                                            alt=""
                                                                            style={{ height: 196, width: 196 }}
                                                                            height={196}
                                                                            width={196}
                                                                        /> : ""
                                                                    }
                                                                </div>
                                                                <hr className="m-1" />
                                                                <div className="qtx-date-time">
                                                                    <h5 className="font-qtx-date-time m-0">
                                                                        <b>{this.state.counter > 0 ? this.state.counter + " วินาที" : ""} </b>
                                                                    </h5>
                                                                    <h5 className="text-danger remark-date-time m-0">
                                                                        โปรดชำระเงินภายในเวลาที่กำหนด
                                                                    </h5>
                                                                </div>
                                                                <hr className="m-1" />
                                                                <div className="bg-success-subtle p-2 mb-2 text-color-details">
                                                                    <div className="font-details-qr-code">
                                                                        {" "}
                                                                        หากเกิดปัญหาฝากเงินหรืออื่นๆ
                                                                        กรุณาติดต่อเจ้าหน้าที่{" "}
                                                                        <b className="text-danger">
                                                                            <a role="button">
                                                                                Line ID : {this.state.linelink}
                                                                            </a>
                                                                        </b>
                                                                    </div>
                                                                </div>
                                                                <a role="button" onClick={(e) => this.cancleqrcode(e, 0)} className="bg-gradient-to-br from-button-f to-button-t flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                        width={16}
                                                                        height={16}
                                                                        fill="currentColor"
                                                                        className="bi bi-x-circle-fill"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                                                    </svg>{" "}
                                                                    {this.state.counter > 0 ? "ยกเลิกรายการ" : "กรุณาทำรายการใหม่"}
                                                                </a>
                                                                {/**/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* panel TrueMoney */}
                            <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40">
                                <button
                                    type="button"
                                    id="_deposit_2"
                                    className="flex items-center justify-between w-full gap-2 px-4 py-3"
                                    onClick={() => this.toggleAccordion('panel-2')}
                                    aria-expanded={this.state.openAccordion === 'panel-2'}
                                    aria-controls="_doposit_body_2"
                                >
                                    <span className="inline-flex gap-2 items-center">
                                        <img loading="lazy" decoding="async" src={require("./assets/member-appufa/icons/deposit-truewallet.png").default} alt="bank" className="w-8 h-8" />
                                        True money
                                    </span>
                                    <svg className={`w-5 h-5 shrink-0 transform transition-transform duration-200 ${this.state.openAccordion === 'panel-2' ? 'rotate-180' : 'rotate-0'}`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.99983 9.76936L5.06396 6.8335H10.9357L7.99983 9.76936Z" fill="white" />
                                    </svg>
                                </button>

                                <div id="_doposit_body_2" className={`${this.state.openAccordion === 'panel-2' ? 'block' : 'hidden'} space-y-2 p-4 pt-1`}>
                                    <p className="" style={{ lineHeight: 1 }}>
                                        ***กรุณาโอนจากเบอร์ที่ลงทะเบียนเท่านั้น
                                    </p>
                                    <p className="" style={{ lineHeight: 1 }}>
                                        ***ไม่รับโอนผ่าน 7-11
                                    </p>
                                    <p className="" style={{ lineHeight: 1 }}>
                                        ***ไม่รับโอนผ่านตู้บุญเติม
                                    </p>
                                    {mainacc !== null ? (
                                        listacc
                                            .filter(listitem => {
                                                if (accnumber !== null) {
                                                    return listitem.bankid === 99; // กรอง bankid == 99
                                                }
                                                return false; // ถ้า accnumber เป็น null ไม่ต้องแสดงรายการ
                                            }).map((listitem, i) => (
                                                <>


                                                    <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] flex items-center justify-between">
                                                        <div className="flex items-center gap-4">
                                                            <img loading="lazy" decoding="async"
                                                                src={require("./assets/member-appufa/icons/bank/truewallet.png").default}
                                                                alt="truewallet"
                                                                className="w-[50px] h-[50px]"
                                                            />
                                                            <div className="w-full text-start text-sm text-gray space-y-0">
                                                                <div className="text-white">ทรูมันนี่วอลเล็ท</div>
                                                                <div className="phone"> {
                                                                    listitem.accnumber
                                                                }</div>
                                                                <div>   {listitem?.first_name_en + " " + listitem?.last_name_en} </div>
                                                            </div>
                                                        </div>
                                                        <button
                                                            href={() => false}
                                                            type="button"
                                                            className="copy-tw text-highlight text-xs inline-flex items-center gap-1"
                                                            onClick={() => this.copyCode(listitem?.accnumber)}
                                                            data-tooltip-trigger="click"
                                                        >
                                                            <img loading="lazy" decoding="async"
                                                                src={require("./assets/member-appufa/icons/copy.svg").default}
                                                                alt="copy"
                                                                className="w-3.5 h-3.5"
                                                            />
                                                            คัดลอก
                                                        </button>
                                                        <div
                                                            id="tooltip-click-30"
                                                            role="tooltip"
                                                            className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium bg-logo rounded-lg shadow-sm opacity-0 tooltip"
                                                            style={{
                                                                position: "absolute",
                                                                inset: "0px auto auto 0px",
                                                                margin: 0,
                                                                transform: "translate(0px, 8px)"
                                                            }}
                                                            data-popper-reference-hidden=""
                                                            data-popper-escaped=""
                                                            data-popper-placement="bottom"
                                                        >
                                                            คัดลอกแล้ว
                                                            <div
                                                                className="tooltip-arrow"
                                                                data-popper-arrow=""
                                                                style={{
                                                                    position: "absolute",
                                                                    left: 0,
                                                                    transform: "translate(0px, 0px)"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>


                                                </>
                                            ))
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>

                            <p className="text-center" style={{ lineHeight: "0.5" }}>
                                ต้องเป็นชื่อเดียวกับที่ลงทะเบียนกับทางเว็บเท่านั้น!!!
                            </p>
                            <br />
                        </div>

                    </div>
                    <div style={{ display: tabselect == 2 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            ถอนเงิน
                        </h1>
                        <h2 className="mb-4 font-medium">ถอนเงินเข้าบัญชีธนาคาร</h2>
                        <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40 p-4 drop-shadow-[0_4px_30px_#ffffff33] from-card-1-f/70 to-card-1-t/70 to-50%">
                            <div className="flex items-center gap-4">
                                <img loading="lazy" decoding="async"
                                    src={accnumber !== null ? accnumberx.img_path : ""}
                                    alt={accnumber !== null ? accnumberx.fullname_th : ""}
                                    className="w-[50px] h-[50px]"
                                />
                                <div className="w-full text-start text-sm text-gray space-y-1">
                                    <div>ชื่อบัญชี : {firstname} </div>
                                    <div>
                                        เลขที่บัญชี : <span className="bankNumber"> {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}</span>
                                    </div>
                                    <div>ธนาคาร : {accnumber !== null ? accnumberx.fullname_th : ""}</div>
                                </div>
                            </div>
                        </div>
                        <h2 className="mt-8 mb-4 font-medium">
                            ยอดเงินที่ถอนได้ : <span id="balance_withdraw">{balance}</span> บาท
                        </h2>

                        <input
                            type="hidden"
                            name="_token"
                            defaultValue="Rpi7bQsO3tihtqu4ofrjvxzTyNC4ZG9mUkFF8uZp"
                        />{" "}
                        <input
                            type="number"
                            className="border border-highlight/60 rounded-xl bg-input block w-full p-2.5 text-center text-lg focus:border-highlight/60"
                            min={1}
                            max={0.0}
                            id="withdraw_amount"
                            onChange={this.onChange}
                            name="withdrawamount"
                            value={this.state.withdrawamount}
                            placeholder="ถอนขั้นต่ำ 100 บาท"
                            autofocus=""
                            autocomplate="off"
                            required=""
                        />
                        <div className="text-sm text-gray font-normal mb-8 mt-2">
                            ***ถอนขั้นต่ำ 100 บาท
                        </div>
                        <div id="submitBTN">
                            <button
                                onClick={(e) => this.submitwithdraw(e)}
                                disabled={
                                    this.state.isWithdrawLoading ||
                                    (this.state.withdrawLockedUntil && this.state.nowTs < this.state.withdrawLockedUntil)
                                }
                                className={`flex items-center justify-center h-12 w-full rounded-md font-semibold ${this.state.isWithdrawLoading ||
                                    (this.state.withdrawLockedUntil && this.state.nowTs < this.state.withdrawLockedUntil)
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-gradient-to-br from-button-f from-40% to-button-t"
                                    }`}
                            >
                                {this.state.isWithdrawLoading
                                    ? "กำลังดำเนินการ..."
                                    : this.state.redirectCountdown > 0
                                        ? `ถอนสำเร็จ กำลังไปหน้าประวัติใน ${this.state.redirectCountdown} วินาที...`
                                        : (this.state.withdrawLockedUntil && this.state.nowTs < this.state.withdrawLockedUntil)
                                            ? `กรุณารอ ${Math.ceil((this.state.withdrawLockedUntil - this.state.nowTs) / 1000)} วินาทีเพื่อทำรายการใหม่อีกครั้ง`
                                            : "ยืนยันการถอนเงิน"}
                            </button>
                        </div>
                    </div>
                    <div style={{ display: tabselect == 8 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            ข้อมูลส่วนตัว
                        </h1>
                        <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a]">
                            <div className="grid grid-cols-2 gap-2 text-sm">
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-1.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="user"
                                    />
                                    ชื่อ-นามสกุล :
                                </div>
                                <div className="text-right">{firstname} </div>
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-2.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="user"
                                    />
                                    เบอร์โทร :
                                </div>
                                <div className="text-right phone">{username}</div>
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-2.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="user"
                                    />
                                    ยูสเซอร์ :
                                </div>
                                <div className="text-right">{usercheck}</div>
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-2.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="user"
                                    />
                                    ผู้แนะนำ :
                                </div>
                                <div className="text-right">ไม่มี</div>
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-4.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="bank"
                                    />
                                    ธนาคารของคุณ :
                                </div>
                                <div className="text-right">{accnumber !== null ? accnumberx.fullname_th : ""}</div>
                                <div className="flex items-center gap-2 text-gray">
                                    <img loading="lazy" decoding="async"
                                        src={require("./assets/member-appufa/icons/profile/icon-4.svg").default}
                                        className="w-[18px] h-[18px]"
                                        alt="bank"
                                    />
                                    เลขที่บัญชี :
                                </div>
                                <div className="text-right bankNumber"> {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}</div>
                            </div>
                        </div>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            เปลี่ยนรหัสผ่าน
                        </h1>
                        <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a]">
                            <input
                                id="old-password"
                                name="oldPassword"
                                placeholder="รหัสผ่านเก่า"
                                type="text"
                                className="border border-highlight/60 rounded-xl bg-input block w-full p-2.5 text-center text-lg focus:border-highlight/60"
                                value={oldPassword}
                                onChange={this.handleChange}
                                required

                            />
                            <div className="text-sm text-gray font-normal mb-8 mt-2">
                                ***พาสเวิดเก่า
                            </div>
                            <input
                                className="border border-highlight/60 rounded-xl bg-input block w-full p-2.5 text-center text-lg focus:border-highlight/60"
                                id="new-password"
                                name="newPassword"
                                placeholder="รหัสผ่านใหม่"
                                type="text"
                                value={newPassword}
                                onChange={this.handleChange}
                                required
                            />
                            <div className="text-sm text-gray font-normal mb-8 mt-2">
                                ***พาสเวิดใหม่
                            </div>
                            <input
                                type="text"
                                id="confirm-password"
                                name="confirmPassword"
                                className="border border-highlight/60 rounded-xl bg-input block w-full p-2.5 text-center text-lg focus:border-highlight/60"
                                placeholder="ยืนยันรหัสผ่านใหม่"
                                value={confirmPassword}
                                onChange={this.handleChange}
                                required
                            />
                            <div className="text-sm text-gray font-normal mb-8 mt-2">
                                ***ยืนยันพาสเวิด
                            </div>
                            <div id="submitBTN">
                                <button onClick={(e) => this.handleSubmit(e)} className="flex items-center justify-center h-12 w-full bg-gradient-to-br from-button-f from-40% to-button-t rounded-md font-semibold">
                                    ยืนยัน
                                </button>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: tabselect == 4 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            รายได้แนะนำเพื่อน
                        </h1>
                        <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40 p-4 from-card-1-f/70 to-card-1-t/70">
                            <div className="flex items-center justify-between">
                                <img loading="lazy" decoding="async"
                                    src={require("./assets/member-appufa/icons/claim.svg").default}
                                    alt="claim"
                                    className="w-12 h-12"
                                />
                                <div className="text-highlight">รับรายได้สัปดาห์ที่แล้ว</div>
                            </div>
                            <div className="flex flex-col gap-4 divide-y divide-white/20">
                                <div className="pt-4">
                                    <h2 className="text-sm">
                                        <span>ระหว่างวันที่ {fmtDate(cashPeriodStart)}</span>
                                        {" "}ถึง{" "}
                                        <span>{fmtDate(cashPeriodEnd)}</span>
                                    </h2>
                                    <div
                                        className="grid grid-cols-2 gap-2 text-sm text-gray mt-4"
                                        role="tabpanel"
                                        aria-labelledby="all-income-tab-1"
                                    >
                                        <h3>เพื่อนที่แนะนำ</h3>
                                        <div className="text-right">{_friendCount} คน</div>
                                        <h3>รับรายได้</h3>
                                        <div className="text-right">{_money(_affCash)}</div>
                                        <h3 />
                                        <div className="text-end"></div>
                                        <br></br>
                                        <a
                                            role="button" onClick={(e) => {
                                                this.opencliaminvite(e, 'bonusrankaccount')
                                            }}
                                            className="bg-gradient-to-br from-button-f to-button-t flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium"
                                        >
                                            รับยอดชวนเพื่อน
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 className="text-sm text-highlight mt-4">คำอธิบาย</h2>
                        <ul className="text-sm list-disc list-inside">
                            <li>คืนเงินรายสัปดาห์ {_lossPct}% ทุกวันจันทร์ หลัง 01.00 น.</li>
                        </ul>
                        <br></br>
                        <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40 p-4 from-card-1-f/70 to-card-1-t/70">
                            <div className="flex items-center justify-between">
                                <img loading="lazy" decoding="async"
                                    src={require("./assets/member-appufa/icons/claim.svg").default}
                                    alt="claim"
                                    className="w-12 h-12"
                                />
                                <div className="text-highlight">รายได้สัปดาห์นี้</div>
                            </div>
                            <div className="flex flex-col gap-4 divide-y divide-white/20">
                                <div className="pt-4">
                                    <h2 className="text-sm">
                                        <span>
                                            ระหว่างวันที่
                                            <span>****</span> ถึง
                                            <span>****</span>
                                        </span>
                                    </h2>
                                    <div
                                        className="grid grid-cols-2 gap-2 text-sm text-gray mt-4"
                                        role="tabpanel"
                                        aria-labelledby="all-income-tab-1"
                                    >
                                        <h3>ยอดรวม</h3>
                                        <div className="text-right">+{(tblprofile != null) ? tblprofile.Cashtotal : 0}</div>
                                        <h3>รายได้ล่าสุด</h3>
                                        <div className="text-right">{(tblprofile != null) ? tblprofile.Cashtotal : 0}</div>
                                        <br></br>
                                        <a
                                            role="button" onClick={(e) => {
                                                this.opencliamcashout(e, 'bonusrankaccount', (tblprofile != null) ? tblprofile.Cashtotal : 0)
                                            }}
                                            className="bg-gradient-to-br from-button-f to-button-t flex items-center justify-center gap-2 text-gray rounded py-2 px-4 font-medium"
                                        >
                                            รับยอดเสีย
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <h2 className="text-xl font-medium mb-4 mt-6">
                            รายชื่อเพื่อนที่เล่นสัปดาห์นี้
                        </h2>
                        <div className="relative">
                            <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] relative overflow-x-auto !p-0 !bg-[#111A33]/70 max-h-[400px] min-h-[550px] max-h-[550px]">
                                <table className="w-full text-center font-normal" id="income_datatable">
                                    <thead className="text-xs text-gray border-b border-white/10">
                                        <tr>
                                            <td className="p-2">ลำดับ</td>
                                            <td className="p-2">ยูส</td>
                                            <td className="p-2">วันที่สมัคร</td>
                                            <td className="p-2">ยอด</td>
                                        </tr>
                                    </thead>
                                    <tbody className="text-sm"></tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <div style={{ display: tabselect == 25 ? "" : "none" }}>
                        <img loading="lazy" decoding="async"
                            className="mt-3"
                            src="https://cdn.javisx.com/image/e00641fb-a5c4-4ebb-9c9b-f11c0a2bc296.jpg"
                        />
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            แนะนำเพื่อน
                        </h1>
                        <div className="grid grid-cols-2 gap-2">
                            <div className={`w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] !p-2 ${tabselectselect === 1 ? "text-highlight border border-highlight" : ""
                                }`}>
                                <a
                                    role="button"
                                    onClick={(e) => {

                                        this.setState({
                                            tabselectselect: 1,
                                        });
                                    }}
                                    className="text-center w-full h-full block text-sm"
                                >
                                    <svg
                                        className="w-6 h-6 mx-auto"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M23.229 10.2258L20.9235 5.81058C20.786 5.55009 20.5522 5.35358 20.272 5.26289C19.9917 5.1722 19.6871 5.19449 19.4231 5.32503L17.1614 6.45584H15.4559L12.2887 5.02277C12.044 4.91223 11.7679 4.89271 11.5101 4.9677L6.80595 6.33911L4.57673 5.22455C4.31268 5.09406 4.00813 5.07178 3.7279 5.16246C3.44768 5.25314 3.21391 5.44961 3.07636 5.71005L0.770791 10.1254C0.701655 10.2578 0.659587 10.4027 0.647041 10.5516C0.634495 10.7005 0.651722 10.8503 0.697717 10.9925C0.743713 11.1346 0.817555 11.2662 0.914936 11.3794C1.01232 11.4927 1.13129 11.5855 1.2649 11.6523L3.54864 12.7942L8.64341 16.778C8.76741 16.8753 8.91059 16.9453 9.06354 16.9833L14.497 18.3417C14.5854 18.3637 14.6762 18.3748 14.7673 18.3748C15.0663 18.3749 15.3533 18.2566 15.5653 18.0458L19.015 14.596C19.022 14.5891 19.0286 14.5819 19.035 14.5745L20.4857 12.8774L22.7349 11.7528C22.8685 11.686 22.9875 11.5932 23.0849 11.4799C23.1823 11.3666 23.2561 11.2351 23.3021 11.0929C23.3481 10.9508 23.3653 10.8009 23.3528 10.652C23.3402 10.5032 23.2982 10.3583 23.229 10.2258ZM18.6901 13.8237L14.8455 11.0276C14.7806 10.9804 14.7023 10.9553 14.6221 10.9559C14.5419 10.9564 14.4641 10.9827 14.3999 11.0308L13.1999 11.9308C12.7447 12.2695 12.1923 12.4525 11.6249 12.4525C11.0575 12.4525 10.5052 12.2695 10.0499 11.9308L9.54173 11.5497C9.49875 11.5175 9.4632 11.4764 9.43749 11.4292C9.41177 11.382 9.39649 11.3299 9.39268 11.2763C9.38887 11.2227 9.39662 11.1689 9.4154 11.1186C9.43418 11.0683 9.46356 11.0226 9.50154 10.9846L13.1704 7.3157C13.2409 7.24562 13.3362 7.20615 13.4356 7.20584H15.3739L15.3747 7.20593L15.376 7.20584H17.0227L19.8002 12.525L18.6901 13.8237ZM1.41129 10.7616C1.3958 10.7142 1.38997 10.6642 1.39415 10.6146C1.39833 10.5649 1.41244 10.5166 1.43565 10.4725L3.74122 6.05717C3.77325 5.99641 3.8213 5.94556 3.88015 5.91013C3.939 5.87471 4.00642 5.85605 4.07511 5.85617C4.1328 5.85612 4.1897 5.86954 4.24128 5.89536L6.24088 6.89512L3.58805 11.9754L1.60035 10.9815C1.55572 10.9594 1.51598 10.9285 1.48351 10.8907C1.45103 10.8529 1.42648 10.809 1.41129 10.7616ZM15.0351 17.5154C14.9892 17.5611 14.9323 17.5942 14.8699 17.6114C14.8075 17.6287 14.7417 17.6296 14.6788 17.614L9.24537 16.2556C9.19441 16.243 9.1467 16.2197 9.10539 16.1873L4.22682 12.3725L6.99866 7.06415L11.7199 5.68776C11.8059 5.6627 11.8979 5.66919 11.9795 5.70607L13.6365 6.45584H13.4356C13.2878 6.45544 13.1414 6.48435 13.0048 6.54091C12.8683 6.59747 12.7444 6.68055 12.6401 6.78534L8.97126 10.4542C8.85727 10.5682 8.76911 10.7053 8.71273 10.8563C8.65635 11.0073 8.63309 11.1687 8.6445 11.3295C8.65592 11.4902 8.70175 11.6467 8.7789 11.7882C8.85605 11.9297 8.96271 12.053 9.09165 12.1497L9.59986 12.5309C10.1852 12.9663 10.8953 13.2015 11.6249 13.2015C12.3545 13.2015 13.0646 12.9663 13.65 12.5309L14.6283 11.797L18.1745 14.376L15.0351 17.5154ZM22.5885 10.862C22.5734 10.9095 22.5488 10.9534 22.5163 10.9912C22.4838 11.029 22.4441 11.0599 22.3995 11.082L20.4118 12.0758L17.7589 6.99559L19.7586 5.99583C19.8466 5.9523 19.9481 5.94485 20.0415 5.97509C20.1349 6.00532 20.2128 6.07085 20.2586 6.1577L22.5642 10.573C22.5874 10.6171 22.6015 10.6654 22.6057 10.715C22.6099 10.7647 22.604 10.8147 22.5885 10.862ZM10.8637 20.0468C10.8518 20.0946 10.8306 20.1395 10.8013 20.1791C10.772 20.2187 10.7352 20.2522 10.693 20.2775C10.6507 20.3029 10.6039 20.3196 10.5552 20.3269C10.5065 20.3341 10.4568 20.3317 10.409 20.3197L7.58341 19.6133C7.41147 19.5701 7.25209 19.4871 7.11814 19.3709L5.00392 17.5331C4.96661 17.5008 4.93604 17.4615 4.91395 17.4174C4.89186 17.3733 4.87869 17.3253 4.87519 17.2761C4.87169 17.2269 4.87792 17.1775 4.89355 17.1307C4.90917 17.0839 4.93386 17.0407 4.96622 17.0035C4.99858 16.9663 5.03796 16.9358 5.08211 16.9138C5.12626 16.8918 5.17432 16.8788 5.22352 16.8754C5.27273 16.872 5.32211 16.8784 5.36885 16.8941C5.4156 16.9098 5.45878 16.9347 5.49592 16.9671L7.61024 18.8049C7.65497 18.8436 7.70815 18.8713 7.76551 18.8858L10.5908 19.592C10.6873 19.6161 10.7703 19.6776 10.8214 19.7629C10.8726 19.8482 10.8878 19.9503 10.8637 20.0468Z"
                                            fill="currentColor"
                                            stroke="currentColor"
                                        />
                                    </svg>
                                    ภาพรวม
                                </a>
                            </div>
                            <div className={`w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] !p-2 ${tabselectselect === 2 ? "text-highlight border border-highlight" : ""
                                }`}>
                                <a
                                    role="button"
                                    onClick={(e) => {

                                        this.setState({
                                            tabselectselect: 2,
                                        });
                                    }}
                                    className="text-center w-full h-full block text-sm"
                                >
                                    <svg
                                        className="w-6 h-6 mx-auto"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.9875 18V18.0125H3H15H15.0125V18V17.2C15.0125 17.0145 14.9661 16.8455 14.8732 16.6935C14.7804 16.5417 14.658 16.4235 14.5061 16.3391L14.5056 16.3388C13.6048 15.8884 12.6956 15.5506 11.778 15.3254C10.8603 15.1001 9.93435 14.9875 9 14.9875C8.06565 14.9875 7.13965 15.1001 6.22202 15.3254C5.30439 15.5506 4.39519 15.8884 3.49441 16.3388L3.4944 16.3388L3.49393 16.3391C3.34199 16.4235 3.2196 16.5417 3.12683 16.6935C3.03392 16.8455 2.9875 17.0145 2.9875 17.2V18ZM1.0125 19.9875V17.2C1.0125 16.6356 1.15771 16.117 1.44815 15.644C1.73865 15.1709 2.12445 14.8101 2.60569 14.5611C3.63819 14.0449 4.68727 13.6577 5.75294 13.3996C6.81864 13.1415 7.90099 13.0125 9 13.0125C10.099 13.0125 11.1814 13.1415 12.2471 13.3996C13.3127 13.6577 14.3618 14.0449 15.3943 14.5611C15.8755 14.8101 16.2614 15.1709 16.5518 15.644C16.8423 16.117 16.9875 16.6356 16.9875 17.2V19.9875H1.0125ZM9 11.9875C7.90334 11.9875 6.96485 11.5972 6.18384 10.8162C5.40283 10.0352 5.0125 9.09666 5.0125 8C5.0125 6.90334 5.40283 5.96485 6.18384 5.18384C6.96485 4.40283 7.90334 4.0125 9 4.0125C10.0967 4.0125 11.0352 4.40283 11.8162 5.18384C12.5972 5.96485 12.9875 6.90334 12.9875 8C12.9875 9.09666 12.5972 10.0352 11.8162 10.8162C11.0352 11.5972 10.0967 11.9875 9 11.9875ZM9 10.0125C9.55334 10.0125 10.0273 9.81533 10.4213 9.42134C10.8153 9.02735 11.0125 8.55334 11.0125 8C11.0125 7.44666 10.8153 6.97265 10.4213 6.57866C10.0273 6.18467 9.55334 5.9875 9 5.9875C8.44666 5.9875 7.97265 6.18467 7.57866 6.57866C7.18467 6.97265 6.9875 7.44666 6.9875 8C6.9875 8.55334 7.18467 9.02735 7.57866 9.42134C7.97265 9.81533 8.44666 10.0125 9 10.0125Z"
                                            fill="currentColor"
                                            stroke="currentColor"
                                            strokeWidth="0.025"
                                        />
                                        <path
                                            d="M18.9 20.5V17.5C18.9 16.7667 18.6958 16.0625 18.2875 15.3875C17.8792 14.7125 17.3 14.1333 16.55 13.65C17.4 13.75 18.2 13.9208 18.95 14.1625C19.7 14.4042 20.4 14.7 21.05 15.05C21.65 15.3833 22.1083 15.7542 22.425 16.1625C22.7417 16.5708 22.9 17.0167 22.9 17.5V20.5H18.9ZM18.9 8.5C18.9 9.6 18.5083 10.5417 17.725 11.325C16.9417 12.1083 16 12.5 14.9 12.5C14.7167 12.5 14.4833 12.4792 14.2 12.4375C13.9167 12.3958 13.6833 12.35 13.5 12.3C13.95 11.7667 14.2958 11.175 14.5375 10.525C14.7792 9.875 14.9 9.2 14.9 8.5C14.9 7.8 14.7792 7.125 14.5375 6.475C14.2958 5.825 13.95 5.23333 13.5 4.7C13.7333 4.61667 13.9667 4.5625 14.2 4.5375C14.4333 4.5125 14.6667 4.5 14.9 4.5C16 4.5 16.9417 4.89167 17.725 5.675C18.5083 6.45833 18.9 7.4 18.9 8.5Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                    เพื่อน
                                </a>
                            </div>
                        </div>
                        <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/40 p-4 rounded-xl drop-shadow-[0_4px_30px_#ffffff33] mt-2 to-70%"  >
                            <div style={{ display: tabselectselect == 1 ? "" : "none" }} >
                                <h2 className="text-highlight text-lg font-medium">รายได้แนะนำเพื่อน </h2>
                                <div className="pt-4 border-t border-white/20">
                                    <h3 className="text-sm mb-2">ลิงค์แนะนำ</h3>
                                    <div className="flex items-center gap-4 !mt-2">
                                        <div className="bg-[#0E0C19]/80 rounded py-1 px-2 text-xs w-full overflow-x-scroll whitespace-nowrap">
                                            {linkaff}
                                        </div>
                                        <button
                                            className="p-0 whitespace-nowrap bg-transparent text-highlight text-sm"
                                                data-tooltip-target="tooltip-click"
                                            onClick={() => this.copyCode(linkaff)}
                                            type="button"
                                        >
                                            คัดลอก
                                        </button>
                                        <div
                                            id="tooltip-click"
                                            role="tooltip"
                                            className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium bg-logo rounded-lg shadow-sm opacity-0 tooltip"
                                            style={{
                                                position: "absolute",
                                                inset: "auto auto 0px 0px",
                                                margin: 0,
                                                transform: "translate3d(297.6px, -46.4px, 0px)"
                                            }}
                                            data-popper-placement="top"
                                        >
                                            คัดลอกแล้ว
                                            <div
                                                className="tooltip-arrow"
                                                data-popper-arrow=""
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    transform: "translate3d(40.8px, 0px, 0px)"
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div style={{ display: tabselectselect == 2 ? "" : "none" }}>
                                <h2 className="text-xl font-medium mb-4 mt-6">เพื่อนที่แนะนำ</h2>
                                <ul className="grid grid-cols-2 gap-2 mb-4" id="tabs_rank" role="tablist"></ul>
                                <div id="rank_1" role="tabpanel" aria-labelledby="rank_1_tab">
                                    <div className="relative">
                                        <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a] relative overflow-x-auto !p-0 !bg-[#111A33]/70 max-h-[400px]">
                                            <table className="w-full text-center font-normal" id="rank_1_datatable">
                                                <thead className="text-xs text-gray border-b border-white/10">
                                                    <tr>
                                                        <td className="p-2">ลำดับ</td>
                                                        <td className="p-2">วันที่สมัคร</td>
                                                        <td className="p-2">เบอร์โทร</td>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-sm"></tbody>
                                                <tbody id="friendAffTableBody"></tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div style={{ display: tabselect == 7 ? "" : "none" }}>
                        {this.state.tabselect == 7 && (
                            <Promotion />
                        )}
                    </div>
                    <div style={{ display: tabselect == 33 ? "" : "none" }}>
                        {this.state.tabselect == 33 && (
                            <Luckywhell
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.navigateTo?.(to, { selection: 1 }); // หรือ checkurl(e, to)
                                }} />
                        )}
                    </div>
                    <div style={{ display: tabselect == 36 ? "" : "none" }}>
                        {this.state.tabselect == 36 && (
                            <Checkindaily
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.checkurl(e, to); // หรือ checkurl(e, to)
                                }}
                            />
                        )}
                    </div>
                    <div style={{ display: tabselect == 37 ? "" : "none" }}>
                        {this.state.tabselect == 37 && (
                            <Cardminigame
                                userid={this.state.username}
                                loginstate={this.state.loginstate}
                                point={this.state.point}
                                onNavigate={(to, e) => {
                                    if (e?.preventDefault) e.preventDefault();
                                    window.history.pushState(null, "", to);
                                    // เรียกฟังก์ชันกลางของคุณ
                                    this.checkurl(e, to); // หรือ checkurl(e, to)
                                }}
                            />
                        )}
                    </div>
                    <div style={{ display: tabselect == 35 ? "" : "none" }}>
                        <h1 className="text-xl text-highlight font-medium text-center mt-8 mb-4">
                            อัพโหลด Slip
                        </h1>
                        <h2 className="mb-4 font-medium">อัพโหลดเฉพาะภาพ Slip</h2>
                        <form className="MuiBox-root css-1f8hzjo">
                            <p className="MuiTypography-root MuiTypography-body1 css-17nk34h">
                                อัลโหลด Slip
                            </p>
                            <div className="MuiBox-root css-10zh34x">
                                {/* ปุ่มอัพโหลดไฟล์ */}
                                <label
                                    htmlFor="upload"
                                    className="btn btn-primary w-100 flex items-center justify-center gap-2 px-4 py-2 rounded-lg cursor-pointer"
                                    id="uploadButton"
                                >
                                    <svg
                                        className="w-5 h-5 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
                                    </svg>
                                    <span className="text-white font-medium">อัปโหลดไฟล์สลิป</span>
                                </label>

                                {/* Input เลือกไฟล์ (ซ่อน) */}
                                <input
                                    type="file"
                                    hidden
                                    onChange={this.handleFileSelectedt}
                                    id="upload"
                                    name="filename"
                                />

                                {/* แสดงภาพพรีวิวถ้ามีไฟล์ที่เลือก */}
                                {this.state.previewUrl && (
                                    <img loading="lazy" decoding="async"
                                        id="imagePreview"
                                        src={this.state.previewUrl}
                                        className="w-full mt-2 rounded-lg border"
                                        alt="Preview"
                                    />
                                )}
                            </div>

                        </form>
                        {this.state.files.length > 0 && !this.state.isConfirmed && (
                            <div id="submitBTN">
                                <button onClick={this.handleConfirmUpload} className="flex items-center justify-center h-12 w-full bg-gradient-to-br from-button-f from-40% to-button-t rounded-md font-semibold">
                                    ยืนยันการอัพโหลด
                                </button>
                            </div>
                        )}
                        {this.state.isConfirmed && (
                            <p className="text-success mt-2">✅ อัปโหลดสลิปสำเร็จแล้ว</p>
                        )}
                    </div>
                    <div className="w-full bg-card p-4 rounded-xl drop-shadow-[0_4px_50px_#ffffff1a]" style={{ display: tabselect == 0 ? "" : "none" }}>
                        <div className="flex items-center justify-between"></div>
                        <br />
                        <img loading="lazy" decoding="async" src="https://cdn.javisx.com/image/e00641fb-a5c4-4ebb-9c9b-f11c0a2bc296.jpg" />
                        <div className="flex flex-col gap-4 divide-y divide-white/20">
                            <div className="pt-4">
                                <p className="text-sm">ยอดชวนเพื่อน ทุกวันจันทร์ หลัง 01.00</p>
                                <div className="flex flex-row justify-end">
                                    <div className="w-2/3 self-center">
                                        <p className="text-highlight text-lg">
                                            <span>รับชวนเพื่อน {_money(_affCash)} บาท</span>
                                        </p>
                                    </div>
                                    <div className="w-1/3 self-center text-right">
                                        <a role="button" className={_btn(_affCash > 0)} onClick={(e) => { if (_affCash > 0) this.opencliaminvite(e, 'bonusrankaccount'); }}>รับ</a>
                                    </div>
                                </div>
                            </div>
                            <img id="zb-cashback" loading="lazy" decoding="async" src="https://cdn.javisx.com/image/3d0bcada-a354-49d0-9236-543852a738c9.jpg" alt="คืนยอดเสีย" />
                            <div className="pt-4">
                                <p className="text-sm">คืนเงินยอดเสียรายสัปดาห์ {_lossPct}% ทุกวันจันทร์ หลัง 01.00</p>
                                <p className="text-sm">รอบ {fmtDate(cashPeriodStart)} - {fmtDate(cashPeriodEnd)}</p>
                                <div className="flex flex-row justify-end">
                                    <div className="w-2/3 self-center">
                                        <p className="text-highlight text-lg">
                                            <span>รับยอดคืน {_money(_lossCash)} บาท</span>
                                        </p>
                                    </div>
                                    <div className="w-1/3 self-center text-right">
                                        <a role="button" className={_btn(_lossCash > 0 && !this.state.claiming)} onClick={(e) => { if (_lossCash > 0 && !this.state.claiming) this.opencliamcashout(e, 'bonusrankaccount'); }}>{this.state.claiming ? "..." : "รับ"}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                {/* <div className={this.state.modalx ? "overlay active" : "overlay "}></div> */}
            </>
        );
    }
}

export default Main;
